<template>
	<div class="navPage positionR noPrint">
		<!-- 20260109新增换种方式处理侧边栏鼠标离开事件 @mouseover.stop="useUserStore().isHover = false" -->

		<!-- 共享打印 -->
		<publicityContentModal></publicityContentModal>

		<div class="navHeight"></div>
		<!-- zIndex101 => zIndex999 -->
		<div @click.stop="foldUpHandle()"
			class="navBlo widthPercentage displayF justifyConB positionF left0 top0 widthPercentage navHeight zIndex999 positionR">
			<!-- 展示全部菜单项/收藏 v-if="useUserStore().isMenu && centerMenuChildrenData" -->
			<div @click.stop="useUserStore().isMenu = false" class="menuBlock positionF left0 zIndex999 boxSizingBorder"
				:class="getParentBloClass()">
				<!-- mask背景 -->
				<div class="transition05 "
					:class="useUserStore().isMenu && centerMenuChildrenData ? 'widthVw heightPercentage back_0005' : 'backgroundNone'">
				</div>

				<!-- 菜单 -->
				<div @click.stop="useUserStore().isMenu = true" class="menuBack displayInlineF borderRight transition05"
					:style="useUserStore().isMenu && centerMenuChildrenData ? '' : 'left: -200%;'">
					<div class="leftMenuBlo borderRight displayF flexDirectionC overflowA flexShrink0">
						<div @click="menuDataHandle(i, item.name)" @mouseover="menuDataHandle(i, item.name)"
							class="padding12_16 borderBottom displayFSpaceBetween boxSizingBorder widthPercentage flexShrink0 cursor "
							:class="menuDataIndex == i ? 'back_DCE01 menuDataColorActive' : 'color_B9B'"
							v-for="(item, i) in menuData" :key="i">
							<div class="displayF12Center height20">
								<img class="imgWH16 marginTop1"
									:src="menuDataIndex == i ? initThemeImg(theme, item.iconLight) : initThemeImg(theme, item.icon)"
									alt="">
								<div class="fontSize14">{{item.name}}</div>
							</div>
							<img v-if="item.children && item.children.length > 0 || i == 0" class="imgWH20"
								:src="initThemeImg(theme, 'public_icon_down_normal@2x')" alt="">
						</div>
					</div>

					<!-- 定制路径 -->
					<div class="displayF">
						<div v-for="(par, parI) in centerMenuChildrenData" :key="parI"
							class="centerMenuBlo boxSizingBorder overflowA heightPercentage transition05 "
							:class="pathIndex == menuDataIndex ? 'borderRight' : 'width0'">
							<div>
								<div class="color_FFF centerMenuName lineHeight14 height14 fontSize14 marginBottom20">
									{{centerMenuChildrenData[parI].name || ' '}}
								</div>

								<div :class="item.type == 2 ? 'menuChildBloSec' : 'menuChildBlo'"
									v-for="(item, i) in par.children" :key="i">
									<div @click.stop="jumpUrlHandle(item.url, '3', '', item)"
										class="nameBloSty whiteSpaceN">
										{{item.name}}
									</div>
									<div v-if="item.type == 1" class="flexShrink0">
										<img v-if="!item.collect" @click.stop="collectHandle(i, item.name, item)"
											class="imgWH12" :src="initThemeImg(theme, 'icon-collect@2x')" alt="">
										<img v-else @click.stop="removeCollectHandle(i, item.name, 'collect', item)"
											class="collectImg imgWH12" :src="initThemeImg(theme, 'icon-collected@2x')"
											alt="">
									</div>
								</div>
							</div>
						</div>
					</div>

					<div v-if="pathIndex != menuDataIndex"
						class="centerMenuBlo borderRight boxSizingBorder overflowA transition05"
						:class="menuDataIndex == 0 ? ' centerMenuBloPar' : ''">
						<!-- 全部功能 -->
						<div v-if="menuDataIndex == 0">
							<div class="centerMenuChild columnGap16">
								<div>
									<div class="centerMenuChildItem" v-for="(item, i) in cardList1" :key="i">
										<div class="bigTitleAllSty color_FFF marginBottom12 paddingLR8 boxSizingBorder">
											{{item.name}}
										</div>

										<div :class="items.type == 2 ? 'menuChildBloSec' : 'menuChildBlo'"
											v-for="(items, index) in item.children" :key="index">
											<div @click.stop="jumpUrlHandle(items.url, '3', '', items)"
												class="nameBloSty">
												{{items.name}}{{!isNaN(items.num) ? '' : ('（' + items.num + '）')}}
											</div>
											<div v-if="items.type == 1" class="flexShrink0">
												<img v-if="!items.collect"
													@click.stop="collectHandle(index, item.name, items)" class="imgWH12"
													:src="initThemeImg(theme, 'icon-collect@2x')" alt="">
												<img v-else
													@click.stop="removeCollectHandle(index, item.name, 'collect', items)"
													class="collectImg imgWH12"
													:src="initThemeImg(theme, 'icon-collected@2x')" alt="">
											</div>
										</div>
									</div>
								</div>
								<div>
									<div class="centerMenuChildItem" v-for="(item, i) in cardList2" :key="i">
										<div class="bigTitleAllSty color_FFF marginBottom12 paddingLR8 boxSizingBorder">
											{{item.name}}
										</div>

										<div :class="items.type == 2 ? 'menuChildBloSec' : 'menuChildBlo'"
											v-for="(items, index) in item.children" :key="index">
											<div @click.stop="jumpUrlHandle(items.url, '3')" class="nameBloSty">
												{{items.name}}{{!isNaN(items.num) ? '' : ('（' + items.num + '）')}}
											</div>
											<div v-if="items.type == 1" class="flexShrink0">
												<img v-if="!items.collect"
													@click.stop="collectHandle(index, item.name, items)" class="imgWH12"
													:src="initThemeImg(theme, 'icon-collect@2x')" alt="">
												<img v-else
													@click.stop="removeCollectHandle(index, item.name, 'collect', items)"
													class="collectImg imgWH12"
													:src="initThemeImg(theme, 'icon-collected@2x')" alt="">
											</div>
										</div>
									</div>
								</div>
								<div>
									<div class="centerMenuChildItem" v-for="(item, i) in cardList3" :key="i">
										<div class="bigTitleAllSty color_FFF marginBottom12 paddingLR8 boxSizingBorder">
											{{item.name}}
										</div>

										<div :class="items.type == 2 ? 'menuChildBloSec' : 'menuChildBlo'"
											v-for="(items, index) in item.children" :key="index">
											<div @click.stop="jumpUrlHandle(items.url, '3', '', items)"
												class="nameBloSty">
												{{items.name}}{{!isNaN(items.num) ? '' : ('（' + items.num + '）')}}
											</div>
											<div v-if="items.type == 1" class="flexShrink0">
												<img v-if="!items.collect"
													@click.stop="collectHandle(index, item.name, items)" class="imgWH12"
													:src="initThemeImg(theme, 'icon-collect@2x')" alt="">
												<img v-else
													@click.stop="removeCollectHandle(index, item.name, 'collect', items)"
													class="collectImg imgWH12"
													:src="initThemeImg(theme, 'icon-collected@2x')" alt="">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div v-else>
							<div class="color_FFF centerMenuName lineHeight14 fontSize14 marginBottom20">
								{{centerMenuData.name}}
							</div>

							<div :class="item.type == 2 ? 'menuChildBloSec' : 'menuChildBlo'"
								v-for="(item, i) in centerMenuData.children" :key="i">
								<div @click.stop="jumpUrlHandle(item.url, '3', '', item)" class="nameBloSty">
									{{item.name}}
								</div>
								<div v-if="item.type == 1" class="flexShrink0">
									<img v-if="!item.collect" @click.stop="collectHandle(i, item.name, item)"
										class="imgWH12" :src="initThemeImg(theme, 'icon-collect@2x')" alt="">
									<img v-else @click.stop="removeCollectHandle(i, item.name, 'collect', item)"
										class="collectImg imgWH12" :src="initThemeImg(theme, 'icon-collected@2x')"
										alt="">
								</div>
							</div>
						</div>
					</div>
					<div v-if="collectMenuShow" class="rightMenuBlo boxSizingBorder overflowA flexShrink0">
						<div class="displayF justifyConB alignItemsC marginBottom24 color_FFF fontSize14 lineHeight16">
							<div>已收藏功能<span v-if="menuDataIndex == 0">({{collectData.length}}/10)</span></div>
							<img @click="closeMenuHandle()" class="imgWH16 cursor"
								:src="initThemeImg(theme, 'icon_sc@2x')" alt="">
						</div>
						<div class="menuChildBlo" v-for="(item, i) in collectData" :key="i">
							<div @click.stop="jumpUrlHandle(item.url, '3', '', item)">{{item.name}}</div>
							<img @click="removeCollectHandle(i, item.name, '', item)" class="imgWH8"
								:src="initThemeImg(theme, 'icon-x-small@2x')" alt="">
						</div>
					</div>
				</div>
			</div>

			<div class="positionR">
				<div v-if="!isMenuHover" @mouseover.stop="isMenuHoverHandle()" @mouseleave.stop="isMenuMouseHandle()"
					class="positionA top0 left0 imgWH52 cursor zIndex10">
				</div>

				<div class="displayF">
					<!-- <div @mouseleave.stop="isMenuMouseHandle()" @click="isMenuHandle()"
						class="imgWH56 displayF alignItemsC justifyConC cursor"
						:class="useUserStore().isMenu ? 'themeBlueBack' : ''">
						<img v-if="useUserStore().isMenu" class="imgWH16" :src="initThemeImg(theme, 'icon-x@2x')"
							alt="">
						<img v-else class="imgWH18" :src="initThemeImg(theme, 'icon@2x')" alt="">
					</div> -->

					<div @mouseleave.stop="isMenuMouseHandle()" @click="isMenuHandle()" class="sdk-nav-v2-nav-menu"
						:class="useUserStore().isMenu ? 'fold' : 'unfold'">
						<span class="sdk-nav-v2-nav-menu__line-first"></span>
						<span class="sdk-nav-v2-nav-menu__line"></span>
						<span class="sdk-nav-v2-nav-menu__line-last"></span>
					</div>

					<div class="headerTapHover displayF10Center paddingL12">
						<img @click="jumpUrlHandle('/')" class="imgWH26 cursor"
							:src="initThemeImg(theme, 'logo_26x26@2x')" alt="">

						<div @click="jumpUrlHandle('/')" class="displayF alignItemsC">
							<div class="displayF8Center cursor">
								<img class="logo" :src="initThemeImg(theme, '53logonew@2x')" alt="">
							</div>

							<!-- 20260128修改 此功能取消 -->
							<!-- <div class="headerTapHoverChild positionA fontSize12 lineHeight18 color_FFF border borderRadius4 whiteSpaceN"
								style="left: calc(50% - 80px);">
								<div @click.stop="jumpUrlHandle('//')" class="positionR">
									前往云联智办
						
									<div class="triangleBloSty"></div>
								</div>
							</div> -->
						</div>
					</div>

					<!-- 20260127之前的版本 -->
					<!-- <img @click="jumpUrlHandle('/')" class="logo displayB cursor"
						:src="initThemeImg(theme, '53logo@2x')" alt="">
					<div v-show="!isSmallSize" @click="jumpUrlHandle('/')" class="headerTapHover displayF alignItemsC">
						<div class="displayF8Center paddingLR16 boxSizingBorder cursor">
							<img class="imgWH16" :src="initThemeImg(theme, 'ywzx@2x')" alt="">
							<div class="color_FFF fontSize12 whiteSpaceN">
								运维中心
							</div>
						</div>

						<div class="headerTapHoverChild positionA fontSize12 lineHeight18 color_FFF border borderRadius4 whiteSpaceN"
							style="left: calc(50% - 54px);">
							<div @click.stop="jumpUrlHandle('//')" class="positionR">
								前往运维中心

								<div class="triangleBloSty"></div>
							</div>
						</div>
					</div> -->
				</div>
			</div>

			<div class="headerSearchBlock displayF columnGap24 alignItemsC">
				<div @click.stop="foldUpHandle('isSearchShow')" ref="headerSearchBloRef"
					class="headerSearchBlo displayF alignItemsC justifyConB columnGap12 border headerSearchBack borderRadius4 boxSizingBorder positionR">
					<img class="imgWH16" :src="initThemeImg(theme, 'icon_ss@2x')" alt="">
					<el-input @click="focusHandle" @focus="focusHandle" @blur="blurHandle" @input="inputHandle()"
						@keyup.enter="enterHandle" ref="headerSearchValRef" v-model="headerSearchVal" v-no-space:leading
						clearable maxlength="200" placeholder="支持使用页面编码快速进入"
						class="headerSearchInput widthPercentage"></el-input>
					<div
						class="shortcutKeys fontSize12 lineHeight18 textAlignC border headerSearchBack borderRadius4 flexShrink0 boxSizingBorder">
						快捷键/
					</div>

					<!-- 获取焦点未开始搜索时 -->
					<div v-if="isHover" class="searchHoverPositionBloSty positionA left0"
						:style="searchHoverLeft && searchHoverLeft < 0 ? ('left: ' + searchHoverLeft + 'px') : ''">
						<div class="searchHoverBloSty">
							<div class="titleBloSty marginBottom8">
								<div>搜索历史</div>
								<div @click="clearHandle('history')" class="clearSty"
									:class="searchHistoryData.length == 0 && searchVisitData.length == 0 ? 'opacity05' : ' '">
									全部清除
								</div>
							</div>

							<div v-if="searchHistoryData.length == 0" class="emptyBloSty">
								<img :src="initThemeImg(theme, 'icon-tips-g@2x')" alt="">
								<div>暂无搜索历史</div>
							</div>
							<div v-else class="searchHistoryColor displayF8Center fontSize12 lineHeight12 flexWrap">
								<div @click.stop="searchHistoryHandle(item)" v-for="(item, i) in searchHistoryData"
									:key="i">
									<elTooltipCommon :data="item.record" :dataRef="'record' + i" :no="true"
										:class="'maxWidth72 cursor paddingTop8 ellipsisSty'">
									</elTooltipCommon>
								</div>
							</div>

							<div class="borderBottom marginTB16"></div>

							<div class="titleBloSty">
								<div>最近访问产品</div>
								<!-- <div @click="clearHandle('visit')" class="clearSty"
									:class="searchVisitData.length > 0 ? '' : ' opacity05'">
									全部清除
								</div> -->
							</div>

							<div v-if="searchVisitData.length == 0" class="emptyBloSty">
								<img :src="initThemeImg(theme, 'icon-tips-g@2x')" alt="">
								<div>暂无最近访问</div>
							</div>
							<div v-else class="displayF16Center color_B9B fontSize12 lineHeight12 flexWrap">
								<div @click="jumpUrlHandle(item.url)" v-for="(item, i) in searchVisitData" :key="i"
									class="searchDataChildBlo">
									<img :src="initThemeImg(theme, item.icon)" alt="" class="img">
									<img :src="initThemeImg(theme, item.iconLight)" alt="" class="selectImg">
									<div>{{item.record}}</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 搜索结果弹窗 数据等为接口动态返回数据**-->
					<div v-if="isSearchShow" class="searchHoverPositionBloSty positionA left0"
						:style="searchHoverLeft && searchHoverLeft < 0 ? ('left: ' + searchHoverLeft + 'px') : ''">
						<div class="searchHoverBloSty">
							<div class="titleBloSty marginBottom16">
								<div class="displayF16Center flexShrink0">
									<div @click="searchDataHandle(null)" class="cursor"
										:class="searchDataIndex == null ? 'color_FFF' : ''">
										全部（{{allNum}}）
									</div>
									<div @click="searchDataHandle(i)" v-for="(item, i) in searchData" :key="i"
										class="cursor"
										:class="(searchDataIndex == i ? 'color_FFF' : '') + (i > 4 ? ' displayN' : '')">
										{{item.name}}（{{item.children ? item.children.length : 0}}）
									</div>
								</div>
							</div>

							<div class="borderBottom marginBottom8"></div>

							<div v-if="searchData.length > 0">
								<div class="searchDataHeight overflowA">
									<div v-if="searchDataIndex == null">
										<div v-for="(item, i) in searchData" :key="i">
											<div class="titleBloSty marginTop16">
												<div>{{item.name}}</div>
												<div @click="searchDataHandle(i)" class="cursorColor cursor">
													查看更多
												</div>
											</div>

											<div class="displayF16Center color_B9B fontSize12 lineHeight12 flexWrap">
												<div @click="jumpUrlHandle(items.url)"
													v-for="(items, index) in item.children" :key="index"
													class="searchDataChildBlo" :class="index > 4 ? 'displayN' : ''">
													<img :src="initThemeImg(theme, items.icon)" alt="" class="img">
													<img :src="initThemeImg(theme, items.iconLight)" alt=""
														class="selectImg">
													<div>{{items.name}}</div>
												</div>

												<div @click="jumpUrlHandle()" class="searchDataChildBlo">
													<img :src="initThemeImg(theme, 'icon-cpwd@2x')" alt="" class="img">
													<img :src="initThemeImg(theme, 'icon-cpwd-select@2x')" alt=""
														class="selectImg">
													<div>产品文档</div>
												</div>
											</div>
										</div>

										<div v-if="isExecute">
											<div class="titleBloSty marginTop16">
												<div>指令名称</div>
											</div>

											<div class="displayF16Center color_B9B fontSize12 lineHeight12 flexWrap">
												<div @click.stop="cmdcommandHandle(items.instructionCode)"
													v-for="(items, index) in cmdcommandData" :key="index"
													class="searchDataChildBlo searchDataChildBloSmall">
													<div>{{items.instructionName}}</div>
												</div>
											</div>
										</div>
									</div>

									<div v-else>
										<div class="displayF16Center color_B9B fontSize12 lineHeight12 flexWrap">
											<div @click="jumpUrlHandle(items.path || items.url)"
												v-for="(items, index) in searchData[searchDataIndex].children"
												:key="index" class="searchDataChildBlo">
												<img :src="initThemeImg(theme, items.icon)" alt="" class="img">
												<img :src="initThemeImg(theme, items.iconLight)" alt=""
													class="selectImg">
												<div>{{items.name}}</div>
											</div>

											<div @click="jumpUrlHandle()" class="searchDataChildBlo">
												<img :src="initThemeImg(theme, 'icon-cpwd@2x')" alt="" class="img">
												<img :src="initThemeImg(theme, 'icon-cpwd-select@2x')" alt=""
													class="selectImg">
												<div>产品文档</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div v-else class="emptyBloSty">
								<img :src="initThemeImg(theme, 'icon-tips-g@2x')" alt="">
								<div>暂无搜索数据</div>
							</div>
						</div>
					</div>
				</div>

				<div @mouseleave="mouseleave()" class="displayF heightPercentage">
					<div @click="jumpUrlHandle(item.path, item.type, i == navMenuData.length + 1 ? 'mailRef' : (i == navMenuData.length + 2 ? 'noticeRef' : ''))"
						@mouseover.stop="mouseover(i, '', i == navMenuData.length ? 'mobileRef' : getRef(item.name), i == navMenuData.length ? 276 : 380)"
						v-for="(item, i) in headerTaps" :key="i" :ref="getRef(item.name)"
						class="headerTap displayF alignItemsC heightPercentage cursor positionR "
						:class="(isSmallSize && i < navMenuData.length ? 'displayNSmall ' : '') + (isHideText && i < navMenuData.length && navMenuData.length != 1 ? '' : 'paddingLR16 ') + (item.type == 2 && item.path ? 'headerTapHover' : '') + ((noticeDrawerShow && i == navMenuData.length + 1) || (settingDrawerShow && i == navMenuData.length + 2 ) ? ' back_DCE01' : '')">
						<div v-if="item.type == 2 && item.path && mouseoverIndex == i"
							class="headerTapHoverChild positionA fontSize12 lineHeight18 color_FFF whiteSpaceN"
							:style="item.path == 'noticeDrawerShow' ? 'left: calc(50% - 43px);' : 'left: calc(50% - 55px);'">
							<!-- <div class="positionR"> -->
							<div class="borderRadius4">
								{{item.path == 'noticeDrawerShow' ? '站内信' : (item.path == 'settingDrawerShow' ? '自定义配置' : '')}}
							</div>

							<!-- <div class="triangleBloSty"></div> -->
							<!-- </div> -->
						</div>

						<div v-if="item.type == 1" class="navMenuData fontSize12 whiteSpaceN "
							:class="navMenuData.length === 1 ? '' : (isHideTextSmall ? 'paddingLR16' : 'paddingLR20')">
							<div class="positionR">
								<img v-if="isHideTextSmall" class="imgWH16" :src="initThemeImg(theme, item.img)" alt="">
								<div v-else>{{item.name}}</div>
								<div v-if="item.name == '服务站' && servicesTopNumData.length > 0 && servicesTopNumData[0].count > 0"
									class="spotSty positionA borderRadius05"></div>
							</div>
						</div>
						<img v-else class="imgWH16" :src="initThemeImg(theme, item.name)" alt="">

						<div v-if="i == (navMenuData.length + 1) && noRead > 0"
							class="noticeNum themeBlueBack positionA borderRadius8 fontSize8 lineHeight12 paddingLR4">
							{{noRead}}
						</div>

						<!-- 悬浮集团账号框体 -->
						<div v-show="mouseoverIndex == i && item.name == '集团账号'" class="commonCardSty"
							:style="'left: ' + hoverCardLeft + 'px;'">
							<div class="displayF justifyConB alignItemsEnd lineHeight14 marginBottom12">
								<div class="fontWeightB fontSize14 color_FFF">
									{{userInfo.companyName}}
								</div>
								<div class="displayF alignItemsC cursor lineHeight12">
									<div @click.stop="jumpUrlHandle('/companyInformation')"
										class="fontSize12 cursorColor">
										了解企业
									</div>
									<img :src="initThemeImg(theme, 'icon-right@2x')" class="imgWH12" alt="">
								</div>
							</div>

							<elTooltipCommon :data="userInfo.introduce || '-'" :dataRef="'introduce'" :no="true"
								:class="'color_B9B fontSize12 lineHeight12 marginBottom32 ellipsisSty'">
							</elTooltipCommon>

							<div class="fontWeightB fontSize14 color_FFF marginBottom16">
								集团账号管理概念
							</div>

							<div class="widthPercentage displayF columnGap12 rowGap12 flexWrap">
								<div @click.stop="jumpUrlHandle(item.path)" v-for="(item, i) in groupAccountData"
									:key="i" class="groupAccountData dataBlo">
									<img :src="initThemeImg(theme, item.selectImg)" alt="" class="selectImg imgWH14">
									<img :src="initThemeImg(theme, item.img)" alt="" class="img imgWH14">
									<div class="fontSize12">
										{{item.name}}
									</div>
								</div>
							</div>
						</div>

						<!-- 悬浮服务站框体  -->
						<div v-show="mouseoverIndex == i && item.name == '服务站'" class="commonCardSty"
							:style="'left: ' + hoverCardLeft + 'px;'">
							<div class="commonTitle">
								服务站
							</div>

							<div class="widthPercentage displayF columnGap12 rowGap12 flexWrap">
								<div
									class="serviceStationData dataBlo dataBloNoAlignCenter paddingLR8 flexDirectionC justifyConC textAlignL lineHeight12 fontSize12 color_FFF">
									<div @click.stop="jumpUrlHandle('/serviceStation')"
										class="widthPercentage displayF8Center">
										<div>待处理</div>
										<div v-if="servicesTopNumData.length > 0" class="color_D24 marginTop2">
											{{servicesTopNumData[0].count || 0}}
										</div>
									</div>
								</div>

								<div @click.stop="jumpUrlHandle(item.path)" v-for="(item, i) in serviceStationData"
									:key="i" class="serviceStationData dataBlo paddingLR12">
									<img :src="initThemeImg(theme, item.selectImg)" alt="" class="selectImg imgWH14">
									<img :src="initThemeImg(theme, item.img)" alt="" class="img imgWH14">
									<div class="fontSize12">
										{{item.name}}
									</div>
								</div>
							</div>
						</div>

						<!-- 悬浮资源库框体 -->
						<div v-show="mouseoverIndex == i && item.name == '资源库'" class="commonCardSty"
							:style="'left: ' + hoverCardLeft + 'px;'">
							<div class="commonTitle">
								资源库
							</div>

							<div class="widthPercentage displayF columnGap12 rowGap12 flexWrap">
								<div @click.stop="jumpUrlHandle(item.path, '', '', item)"
									v-for="(item, i) in resourceLibraryData" :key="i"
									class="resourceLibraryData dataBlo">
									<img :src="initThemeImg(theme, item.selectImg)" alt="" class="selectImg imgWH14">
									<img :src="initThemeImg(theme, item.img)" alt="" class="img imgWH14">
									<div class="fontSize12">
										{{item.name}}
									</div>
								</div>
							</div>
						</div>

						<!-- 悬浮工具箱框体 -->
						<div v-show="mouseoverIndex == i && item.name == '工具箱'" class="commonCardSty"
							:style="'left: ' + hoverCardLeft + 'px;'">
							<div class="commonTitle">
								工具箱
							</div>

							<div class="widthPercentage displayF columnGap12 rowGap12 flexWrap">

								<div @click.stop="jumpUrlHandle(item.path)" v-for="(item, i) in toolboxData" :key="i"
									class="groupAccountData dataBlo">
									<img :src="initThemeImg(theme, item.selectImg)" alt="" class="selectImg imgWH14">
									<img :src="initThemeImg(theme, item.img)" alt="" class="img imgWH14">
									<div class="fontSize12">
										{{i == 1 ? ((isDev ? '正式' : '测试') + '环境') : item.name}}
									</div>
								</div>
							</div>
						</div>

						<!-- 悬浮移动端框体 -->
						<div v-show="mouseoverIndex == i && item.name == 'icon-xcx1024@2x'"
							class="commonCardSty mobileTerminalCardSty transition05"
							:style="'left: ' + hoverCardLeft + 'px; right: ' + (noticeDrawerShow && item.name == 'icon-notice1024@2x' ? '0' : '-388px')">
							<div class="logoBlo borderBottom displayF12Center">
								<img :src="initThemeImg(theme, 'logo_55@2x')" alt="" class="imgWH36">
								<div>
									<div class="fontWeightB fontSize14 lineHeight14 color_FFF marginBottom6">手机扫一扫
									</div>
									<div class="fontSize12 lineHeight12 color_B9B">移动管理 高效管控-掌握实时信息</div>
								</div>
							</div>

							<div class="displayF columnGap48 marginTop24">
								<div class="displayF flexDirectionC rowGap16 marginLeft24">
									<div v-for="(item, i) in mobileTerminalData"
										class="displayF12Center lineHeight14 fontSize14 color_B9B">
										<img :src="initThemeImg(theme, 'icon-check-mark@2x')" alt=""
											class="checkMarkImg displayB">
										<div class="flexShrink0">{{item.name}}</div>
									</div>
								</div>

								<img :src="initThemeImg(theme, 'logo_55@2x')" alt="" class="imgWH74">
							</div>
						</div>

						<!-- 点击站内信框体 v-show="noticeDrawerShow && i == 5"-->
						<div @mouseover.stop="mouseover(i, 'noHover')" @click.stop="stopHandle()"
							class="commonDrawerSty noticeDrawerSty commonDrawerStySec transition05"
							:style="'left: ' + mailLeft + 'px; right: ' + (noticeDrawerShow && item.name == 'icon-notice1024@2x' ? '0' : '-388px')">
							<div class="commonDrawerTitle">
								<div>
									站内信
								</div>

								<div class="displayF columnGap16 alignItemsC">
									<div @click="showMoreHandle()" class="cursor cursorColor fontSize12 fontWeight400">
										查看更多
									</div>
									<img @click.stop="cancelHandle" :src="initThemeImg(theme, 'icon_sc@2x')" alt="">
								</div>
							</div>

							<div class="padding16 boxSizingBorder displayF justifyConB">
								<div class="displayF columnGap16">
									<div
										class="noticeTabsSty borderRadius2 lineHeight26 textAlignC flexShrink0 displayF fontSize12">
										<div @click="noticeTabsHandle(item.key)" v-for="(item, i) in noticeTabsData"
											:key="i" class="flex1"
											:class="noticeTabKey == item.key ? 'noticeTabActive' : 'noticeTabColor'">
											{{item.name}}
										</div>
									</div>

									<el-cascader @change="sysnoticestationletterListApi" v-model="typeId"
										placeholder="全部" :props="cascaderProps" :options="typeIdData"
										:popper-class="'cascaderBloStySmall'" clearable :show-all-levels="false"
										size="default" class="cascaderBloSty width116" />
								</div>

								<div class="displayF columnGap4 alignItemsC fontSize12 lineHeight12 cursorColor"
									:class="noticeData.length > 0 ? '' : 'opacity05'">
									<img :src="initThemeImg(theme, 'icon-all-read@2x')" alt="" class="imgWH12">
									<div @click="allReadHandle()">全部已读</div>
								</div>
							</div>

							<div class="noticeDataHeight overflowA">
								<div v-if="noticeData.length > 0" @click="showMoreHandle(item)"
									@mouseover.stop="noticeMouseover(i)" @mouseleave.stop="noticeMouseleave()"
									v-for="(item, i) in noticeData" :key="i"
									class="noticeData boxSizingBorder displayF columnGap12 "
									:class="noticeMouseoverIndex == i ? 'noticeMouseoverBack' : ''">
									<div class="line flexShrink0" :class="!item.read ? 'lineActive' : 'lineDefault'">
									</div>
									<div class="fontSize12 lineHeight12">
										<elTooltipCommon :data="item.title" :dataRef="'title' + i" :no="true"
											:class="'width342 color_FFF ellipsisSty marginBottom12'">
										</elTooltipCommon>

										<div class="displayF justifyConB alignItemsC">
											<div class="displayF12Center">
												<div class="noticeTypeSty"
													:style="'color: ' + item.colour + ';background: ' + item.backgroundColour + ';border: 1px solid ' + item.borderColour">
													{{item.typeName}}
												</div>
												<div v-if="noticeMouseoverIndex == i && !item.read"
													@click.stop="markHandle(item)" class="cursorColor cursor">
													标为已读
												</div>
											</div>

											<div class="receiveTime">
												{{item.receiveTime}}
											</div>
										</div>
									</div>
								</div>

								<div v-else class="displayFCenter heightPercentage">
									<div>
										<div>
											<img :src="noticeTabKey === '' ? initThemeImg(theme, 'icon-nodata-message@2x') : initThemeImg(theme, 'icon-nodata-noread@2x')"
												alt="" class="imgWH32 margin0Auto">
										</div>
										<div class="noDataText textAlignC marginTop16 lineHeight20 fontSize14">
											{{noticeTabKey === '' ? '暂无数据' : '没有未读信件'}}
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 点击自定义配置框体 v-show="settingDrawerShow && i == 6" -->
						<div @mouseover.stop="mouseover(i, 'noHover')" @click.stop="stopHandle()"
							class="commonDrawerSty commonDrawerStySec transition05 cursorDefault"
							:style="'left: ' + mailLeft + 'px; right: ' + (settingDrawerShow && item.name == 'icon-setting1024@2x' ? '0' : '-388px')">
							<div class="commonDrawerTitle">
								<div>
									自定义配置
								</div>
								<img @click.stop="cancelHandle" :src="initThemeImg(theme, 'icon_sc@2x')" alt="">
							</div>

							<div class="overflowA" style="height: calc(100% - 56px);">
								<div class="commonDrawerTitleSec">
									主题
								</div>
								<div class="displayF justifyConB paddingLR16 borderBottom">
									<div @click="settingHandle(item.id, 'theme')" v-for="(item, i) in settingData"
										:key="i" class="marginBottom16 cursor">
										<div class="borderRadius2 overflowH marginBottom8 positionR padding4 "
											:class="userConfigData.theme == item.id ? 'themeImgBloActive' : 'themeImgBlo'">
											<img :src="item.img" alt="" class="themeImg">
											<img v-if="userConfigData.theme == item.id"
												:src="initThemeImg(theme, 'icon-theme-check@2x')" alt=""
												class="imgWH12 positionA themeActiveImg">
										</div>
										<div class="themeTextColor fontSize12 lineHeight16 textAlignC">{{item.name}}
										</div>
									</div>
								</div>

								<div class="commonDrawerTitleSec">
									阅读模式
								</div>
								<div class="modeDataCommonSty">
									<div @click="settingHandle(item.id, 'read')" v-for="(item, i) in readingModeData"
										:key="i">
										<div class="modeCommonSty">
											<img v-if="userConfigData.readModel == item.id"
												:src="initThemeImg(theme, 'icon-check@2x')" alt="" class="imgWH12">
											<img v-else :src="initThemeImg(theme, 'icon-nocheck@2x')" alt=""
												class="imgWH12">
											<div class="color_FFF">
												<div class="nameSty">{{item.name}}</div>
												<div class="tipsSty">{{item.tips}}</div>
											</div>
										</div>
									</div>
								</div>

								<div class="commonDrawerTitleSec">
									快捷键
								</div>
								<div class="paddingLR18 borderBottom">
									<div class="displayF4Center widthPercentage">
										<el-button type="primary"
											class="cursorDefault">{{getSureText('保存')}}</el-button>
										<el-button class="cursorDefault">{{getCancelText()}}</el-button>
									</div>

									<div class="lineHeight14 fontSize10 color_B9B marginTB16">
										<div>
											当界面含有「」符号，代表开启快捷键功能
										</div>
										<div>
											选中下方组合为开启快捷键功能，未选择则为禁用
										</div>
									</div>

									<div>
										<el-checkbox-group @change="settingHandle(item.id, 'shortcutKey')"
											v-model="userConfigData.shortcutModelArr">
											<el-checkbox v-for="(item, i) in shortcutKeyData" :key="item.value"
												:value="item.value">{{item.label}}</el-checkbox>
										</el-checkbox-group>
									</div>
								</div>

								<div class="commonDrawerTitleSec">
									侧边栏
								</div>
								<div class="modeDataCommonSty">
									<div @click="settingHandle(item.id, 'sideModel')" v-for="(item, i) in sideModelData"
										:key="i">
										<div class="modeCommonSty">
											<img v-if="userConfigData.sideModel == item.id"
												:src="initThemeImg(theme, 'icon-check@2x')" alt="" class="imgWH12">
											<img v-else :src="initThemeImg(theme, 'icon-nocheck@2x')" alt=""
												class="imgWH12">
											<div class="color_FFF">
												<div class="nameSty">{{item.name}}</div>
												<div class="tipsSty">{{item.tips}}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div @mouseover.stop="mouseover('avatar')"
						class="navAvatarBlo displayF alignItemsC columnGap12 paddingLR16 lineHeight12 positionR">
						<div class="fontSize12 depColor textAlignC">
							<div v-if="isLogin" @click.stop="jumpUrlHandle('/accountMessPage')"
								class="width84 cursor whiteSpaceN overflowH">
								<div class="nameColor marginBottom4">{{userInfo.serviceName}}</div>
								<div>{{userInfo.departmentName}}</div>
							</div>
							<div v-else @click="goLogin()" class="cursor whiteSpaceN">请先登录</div>
						</div>
						<img v-if="isLogin" @click.stop="jumpUrlHandle('/accountMessPage')" class="avatarSty"
							:src="userInfo.avatar" alt="">
						<img v-else @click="goLogin()" class="imgWH32 borderRadius05 cursor"
							:src="initThemeImg(theme, 'defaultAvatar@2x')" alt="">

						<!-- 悬浮头像框体 v-show="mouseoverIndex == 'avatar'" -->
						<div class="commonCardSty avatarCardSty transition05 overflowH "
							:class="mouseoverIndex == 'avatar' ? 'height326 opacity1' : 'height0 opacity0'">
							<div class="padding16 boxSizingBorder positionR borderBottom">
								<div class="widthPercentage displayF columnGap4 alignItemsC marginBottom6">
									<div @click.stop="copyHandle(userInfo.companyOrganizationName)"
										class="fontWeightB cursor fontSize14 color_FFF lineHeight20">
										{{userInfo.companyOrganizationName}}
									</div>

									<img :src="initThemeImg(theme, 'icon_fz@2x')" alt="" class="imgWH12">
								</div>

								<div class="fontSize12 color_FFF lineHeight16 displayF columnGap8 alignItemsC">
									<div class="color_B9B">账号ID:</div>
									<div @click.stop="copyHandle(userInfo.username)"
										class="displayF columnGap4 alignItemsC cursor">
										<div>
											{{userInfo.username}}
										</div>

										<img :src="initThemeImg(theme, 'icon_fz@2x')" alt="" class="imgWH12">
									</div>
								</div>

								<div v-if="userInfo.authEntity" class="rzStatus positionA"
									:style="'color: ' + userInfo.authEntity.colour + '; background: ' + userInfo.authEntity.backgroundColour">
									{{userInfo.authEntity.name}}
								</div>
							</div>

							<div class="jumpUrlData boxSizingBorder borderBottom cursor">
								<div @click="jumpUrlHandle(item.path)" v-for="(item, i) in jumpUrlData" :key="i"
									class="fontSize14 color_B9B lineHeight32 paddingLR16 boxSizingBorder">
									{{item.name}}
								</div>
							</div>

							<div @click="logoutHandle()" class="logoutText textAlignC fontSize14 cursor lineHeight42">
								退出
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 点击退出登录 -->
		<tipModal v-if="logoutModal" :text="'是否确认退出'" :loadingReset="loadingReset" @sureHandle="sureHandle"
			@cancelHandle="cancelHandle"></tipModal>
		<!-- 登录账号发生变更弹窗 -->
		<showLogoutModal v-if="showLogoutModalShow" :showLogoutNum="showLogoutNum" @sureHandle="showLogoutModalHandle">
		</showLogoutModal>
		<!-- 共享打印弹窗 -->
		<!-- <sharedPrintingModal v-if="sharedPrintingModalShow" @cancelHandle="cancelHandle"></sharedPrintingModal> -->
	</div>
</template>

<script setup>
	import {
		goLogin,
		initTheme,
		resetLogin,
		getSureText,
		initThemeImg,
		rzStatusText,
		getCancelText,
		znxStatusText,
		rzStatusClass,
		znxStatusClass,
		getLeftMenuList,
		isGetPermission,
		setMessageQueue,
		getNotEditableShow,
		sysmenupowerPowerInApi
	} from '@/utils/common.js'
	import useUserStore from '@/store/modules/user.js'
	import tipModal from '@/components/tipModal'
	import showLogoutModal from '@/components/showLogoutModal'
	import {
		sysSysmenuNav,
		homesearchList,
		homeSearchSearch,
		homesearchRemoveAll,
		homeSearchCheckSearch,
		sysmenupowerDynamicMenu,
		cacheDeleteCacheByToken,
		corecollectCollectOrCancel,
		configuserpersonalizedInfo,
		configuserpersonalizedUpdate
	} from '@/api/user'
	import {
		sysnoticestationletterList,
		sysnoticestationletterReadLetter,
		sysnoticestationlettertypeListAll,
		sysnoticestationletterstatusReadAll
	} from '@/api/systemNotification'
	import {
		cmdcommandList
	} from '@/api/toolbox'
	import defaultSettings from '@/settings'
	import useClipboard from "vue-clipboard3";

	const {
		toClipboard
	} = useClipboard();

	const props = defineProps({
		clickProps: {
			type: Object,
			default: () => {}
		}
	})
	const {
		proxy
	} = getCurrentInstance()
	const router = useRouter()
	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
	const userInfo = computed(() => {
		return useUserStore().userInfo
	})
	const isLogin = computed(() => {
		return useUserStore().isLogin
	})
	// 配置数据
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	})
	// 服务站数据
	const servicesTopNumData = computed(() => {
		return useUserStore().servicesTopNumData || []
	})
	// 我的收藏数据最多展示前十个（目前也只有十个）
	const collectData = computed(() => {
		return useUserStore().collectData
	})
	// 获取站内信--未读条数
	const noRead = computed(() => {
		return useUserStore().noRead
	})
	const sidebarObj = computed(() => {
		return useUserStore().sidebarObj
	}) // 获取菜单 对应标题+图标
	const sidebarData = computed(() => {
		return useUserStore().sidebarObj.children || []
	}) // 菜单数据
	const navMenuData = computed(() => {
		return useUserStore().navMenuData || []
	}) // 获取顶部导航栏动态数据
	// 获取1公版 0内测权限
	const isHavePerssion = computed(() => {
		return useUserStore().isHavePerssion
	})
	const jumpOpenUrl = computed(() => {
		return defaultSettings.officialWebsiteJumpLinkHelp
	})

	const mailLeft = ref(null) // 站内信弹窗left
	const hoverCardLeft = ref(null) // 工具箱/移动端 弹窗hover时left
	const headerSearchVal = ref('') // 搜索
	const searchHoverLeft = ref(null) // 搜索 弹窗hover时left
	// const isMenu = ref(false) // 是否展示全部功能菜单
	const isMenuHover = ref(false) // 悬浮展示全部功能菜单
	const logoutModal = ref(false)
	const isDev = ref(null) // 当前系统是正式/测试
	// const headerTaps = [{
	// 	type: '1', // 1名称 2图片
	// 	name: '集团账号',
	// 	path: '/memberAccount',
	// 	img: 'icon-jtzh-nav@2x',
	// 	children: []
	// }, {
	// 	type: '1',
	// 	name: '服务站',
	// 	path: '/serviceStation',
	// 	img: 'icon-fwz-nav@2x',
	// 	children: []
	// }, {
	// 	type: '1',
	// 	name: '资源库',
	// 	path: '//',
	// 	img: 'icon-zyzx-nav@2x',
	// 	children: []
	// }, {
	// 	type: '1',
	// 	name: '工具箱',
	// 	path: '/terminalPage',
	// 	img: 'icon-gjl1024@2x',
	// 	children: []
	// }, {
	// 	type: '2',
	// 	name: 'icon-xcx1024@2x',
	// 	path: '',
	// 	children: []
	// }, {
	// 	type: '2',
	// 	name: 'icon-notice1024@2x',
	// 	path: 'noticeDrawerShow',
	// 	children: []
	// }, {
	// 	type: '2',
	// 	name: 'icon-setting1024@2x',
	// 	path: 'settingDrawerShow',
	// 	children: []
	// }]
	const headerTaps = ref([])
	const pathIndex = ref(null) // 定制路径索引
	const menuDataIndex = ref(0)
	const menuData = ref([])
	const total = ref(0) // 总数
	const cardList1 = ref([]) // 各列的数据
	const cardList2 = ref([])
	const cardList3 = ref([])
	const centerMenuData = ref([]) // 中间展示的菜单数据
	const centerMenuChildrenData = ref([]) // 定制路径--中间展示的菜单数据
	const collectMenuShow = ref(true) // 右侧收藏功能显示
	const mouseoverIndex = ref(null) // avatar index 框体显示
	const noticeDrawerShow = ref(false) // 站内信抽屉
	const settingDrawerShow = ref(false) // 自定义配置抽屉
	const typeId = ref('') // 站内信--消息类型
	const typeIdData = ref([]) // 站内信--消息类型数据
	const jumpUrlData = ref([{
		name: '账号信息',
		path: '/accountMessPage'
	}, {
		name: '实名认证',
		path: '/realNameAuthentication'
	}, {
		name: '收支明细',
		path: '/incomeAndExpenditureDetails'
	}, {
		name: '队列数传',
		path: '/exportQueuePage'
	}, {
		name: '我的反馈',
		path: '/myFeedback'
	}, {
		name: '安全设置',
		path: '/securitySettingPage'
	}])

	const groupAccountIndex = ref(0) // 集团账号索引
	const groupAccountData = ref([{
		name: '成员信息',
		path: '/memberAccount',
		img: initThemeImg(theme.value, 'icon-cyzhgl@2x'),
		selectImg: initThemeImg(theme.value, 'icon-cyzhgl-select@2x'),
	}, {
		name: '部门管理',
		path: '/departmentManagement',
		img: initThemeImg(theme.value, 'icon-bmgl@2x'),
		selectImg: initThemeImg(theme.value, 'icon-bmgl-select@2x'),
	}, {
		name: '企业信息',
		path: '/companyInformation',
		img: initThemeImg(theme.value, 'icon-qyxx@2x'),
		selectImg: initThemeImg(theme.value, 'icon-qyxx-select@2x'),
	}, {
		name: '变更日志',
		path: '/changeLogs',
		img: initThemeImg(theme.value, 'icon-bgrz@2x'),
		selectImg: initThemeImg(theme.value, 'icon-bgrz-select@2x'),
	}, {
		name: '集团配置',
		path: '/groupConfiguration',
		img: initThemeImg(theme.value, 'icon-jtpz@2x'),
		selectImg: initThemeImg(theme.value, 'icon-jtpz-select@2x'),
	}]) // 集团账号数据
	const serviceStationData = ref([{
		name: '用户者社区',
		path: '',
		img: initThemeImg(theme.value, 'icon-yhzsq@2x'),
		selectImg: initThemeImg(theme.value, 'icon-yhzsq-select@2x'),
	}, {
		name: '帮助文档',
		path: '',
		img: initThemeImg(theme.value, 'icon-bzwd@2x'),
		selectImg: initThemeImg(theme.value, 'icon-bzwd-select@2x'),
	}]) // 服务站数据
	const resourceLibraryData = ref([{
		name: '应用程序',
		path: '',
		img: initThemeImg(theme.value, 'icon-yycx@2x'),
		selectImg: initThemeImg(theme.value, 'icon-yycx-select@2x'),
	}, {
		name: '系统装机',
		path: '',
		img: initThemeImg(theme.value, 'icon-xtzj@2x'),
		selectImg: initThemeImg(theme.value, 'icon-xtzj-select@2x'),
	}, {
		name: '脚本工具',
		path: '',
		img: initThemeImg(theme.value, 'icon-jbgj@2x'),
		selectImg: initThemeImg(theme.value, 'icon-jbgj-select@2x'),
	}, {
		name: '文件模版',
		path: '',
		img: initThemeImg(theme.value, 'icon-wjmb@2x'),
		selectImg: initThemeImg(theme.value, 'icon-wjmb-select@2x'),
	}, {
		name: '壁纸',
		path: '',
		img: initThemeImg(theme.value, 'icon-bz@2x'),
		selectImg: initThemeImg(theme.value, 'icon-bz-select@2x'),
	}, {
		name: '共享打印',
		path: '//',
		img: initThemeImg(theme.value, 'icon-gxdy@2x'),
		selectImg: initThemeImg(theme.value, 'icon-gxdy-select@2x'),
	}]) // 资源库数据
	const toolboxData = ref([{
		name: '终端',
		path: '/terminalPage',
		img: initThemeImg(theme.value, 'icon_zd_g@2x'), // icon-zd@2x
		selectImg: initThemeImg(theme.value, 'icon_zd_h@2x'), // icon-zd-select@2x
	}, {
		name: '测试环境',
		path: '///',
		img: initThemeImg(theme.value, 'icon_cshj_g@2x'), // icon-cshj@2x
		selectImg: initThemeImg(theme.value, 'icon_cshj_h@2x'), // icon-cshj-select@2x
	}, {
		name: '操作日志',
		path: '', // /operationLog
		img: initThemeImg(theme.value, 'icon_czrz_g@2x'), // icon-czrz@2x
		selectImg: initThemeImg(theme.value, 'icon_czrz_h@2x'), // icon-czrz-select@2x
	}, {
		name: '指令手册',
		path: '/instructionManual',
		img: initThemeImg(theme.value, 'icon-zlsc@2x'),
		selectImg: initThemeImg(theme.value, 'icon-zlsc-select@2x'),
	}]) // 工具箱数据
	// , {
	// 	name: '工具配置',
	// 	path: '', // /toolConfiguration
	// 	img: initThemeImg(theme.value, 'icon_gjpz_g@2x'),
	// 	selectImg: initThemeImg(theme.value, 'icon_gjpz_h@2x'),
	// }
	const mobileTerminalData = ref([{
		name: '告警接收',
	}, {
		name: '远程操作',
	}, {
		name: '资源管理',
	}]) // 移动端数据
	const settingData = ref([{
		name: '亮色模式',
		img: initThemeImg(theme.value, 'icon-lsms@2x'),
		id: 'bright'
	}, {
		name: '暗色模式',
		img: initThemeImg(theme.value, 'icon-asms@2x'),
		id: 'dark'
	}, {
		name: '混色模式',
		img: initThemeImg(theme.value, 'icon-hsms@2x'),
		id: 'blend'
	}]) // 主题数据
	const readingModeData = ref([{
		name: '页面内查看',
		tips: '替换展示区域，在当前页面展示',
		id: 'inside',
	}, {
		name: '新页面查看',
		tips: '点击文档链接，在新页面打开',
		id: 'newPage',
	}]) // 阅读模式数据
	const shortcutKeyData = ref([{
		label: 'Shift+Enter 组合；蓝色符号，用于数据提交等操作',
		value: 1
	}, {
		label: 'Enter 组合；蓝色符号，用于二级弹窗确定等操作',
		value: 2
	}, {
		label: 'Esc组合；灰色符号，用于返回或取消等操作',
		value: 3
	}]) // 快捷键 shift+enter:1、enter：2、esc：3
	const sideModelData = ref([{
		name: '固定展开收起',
		tips: '点按钮切换展开或收起，状态固定。',
		id: 'sideFixed',
	}, {
		name: '悬停展开（可固定）',
		tips: '鼠标移入展开移出收起；展开时可固定，固定后可取消。',
		id: 'sideFloat',
	}]) // 侧边栏数据
	const noticeTabKey = ref('')
	const noticeTabsData = ref([{
		name: '全部',
		key: '',
	}, {
		name: '未读',
		key: '0',
	}])
	const noticeData = ref([])
	const isHover = ref(false)
	const searchHistoryData = ref([]) // 搜索历史数据
	const searchVisitData = ref([]) // 搜索访问数据
	const allNum = ref(0) // 搜索出的全部数据
	const searchDataIndex = ref(null)
	const searchData = ref([])
	const isClear = ref(false) // 点击清除
	const isSearchShow = ref(false) // 搜索结果弹窗显示
	const isExecute = ref(false) // true为执行指令
	const cmdcommandData = ref([]) // 所有指令数据
	const setIntervalTime = ref(null) // 查询站内信未读数量轮询
	const cascaderProps = ref({
		value: 'id',
		label: 'name',
		children: 'child',
		emitPath: false
	})
	const loadingReset = ref(false) // 20260302 新增 报错时重置loading状态 报错时true/false提交时

	// watch clickProps
	watch(() => props.clickProps, val => {
		// console.log(val, 'watch clickProps')
		// 20260921 新增
		localStorage.setItem('noticeDrawerShow', val.noticeDrawerShow)
		noticeDrawerShow.value = val.noticeDrawerShow
		settingDrawerShow.value = val.settingDrawerShow
		isSearchShow.value = val.isSearchShow

		if (noticeDrawerShow.value) {
			// 获取站内信
			sysnoticestationletterListApi()
		}
		// 点击后清除搜索项内容
		clearMethods()
		// console.log(headerSearchVal.value, 'headerSearchVal.value')
	}, {
		deep: true,
		immediate: true
	})

	// 监听顶部导航栏数据
	watch(() => navMenuData.value, val => {
		// console.log(val, 'watch navMenuData 监听顶部导航栏数据')
		const arr = JSON.parse(JSON.stringify(val))
		// type 1名称 2图片
		const defaultArr = [{
			type: '2',
			name: 'icon-xcx1024@2x',
			path: '',
			children: []
		}, {
			type: '2',
			name: 'icon-notice1024@2x',
			path: 'noticeDrawerShow',
			children: []
		}, {
			type: '2',
			name: 'icon-setting1024@2x',
			path: 'settingDrawerShow',
			children: []
		}]
		headerTaps.value = arr.concat(defaultArr)
		headerTaps.value.map(item => {
			if (item.name === '集团账号') {
				groupAccountData.value = item.children || []
			} else if (item.name === '服务站') {
				item.children.splice(0, 1)
				serviceStationData.value = item.children || []
			} else if (item.name === '资源库') {
				resourceLibraryData.value = item.children || []
			} else if (item.name === '工具箱') {
				toolboxData.value = item.children || []
			}
		})
	}, {
		deep: true,
		immediate: true
	})

	// 导航栏--搜索框弹窗收起机制
	function foldUpHandle(type) {
		// 点击搜索框相关--不关闭弹窗
		if (type === 'isSearchShow') {
			return
		} else {
			headerSearchVal.value = ''
			isSearchShow.value = false
			isExecute.value = false
			isTab.value = false
			// noticeDrawerShow.value = false
			// settingDrawerShow.value = false
		}

		// else if (type === 'noticeDrawerShow') {
		// 	isSearchShow.value = false
		// 	settingDrawerShow.value = false
		// 	return
		// } else if (type === 'settingDrawerShow') {
		// 	isSearchShow.value = false
		// 	noticeDrawerShow.value = false
		// 	return
		// }
	}

	// 点击搜索历史数据项
	function searchHistoryHandle(item) {
		headerSearchVal.value = item.record
		isTab.value = true

		// 输入框获取焦点
		focusHandle()
		// 搜索(不防抖)
		inputHandle('noTimeout')
	}

	// 点击复制
	function copyHandle(val) {
		// 调用方法获取链接
		toClipboard(val);
		setMessageQueue('success', '复制成功')
	}

	// 获取菜单动态class***
	function getParentBloClass() {
		let str = ''
		if (menuDataIndex.value == 0) {
			str = 'menuAllBlo'
		} else if (menuDataIndex.value == pathIndex.value) {
			let len = centerMenuChildrenData.value.length
			if (len >= 2) {
				str = 'pathBloSty' + len
			}

			// console.log(str, 'getParentBloClass')
		}
		return str
	}

	const isTab = ref(false) // 点击切换
	// 点击切换展示当前项全部搜索数据
	function searchDataHandle(index) {
		searchDataIndex.value = index
		isTab.value = true
		// 输入框获取焦点
		focusHandle()
	}

	function getRef(index) {
		let str = ''
		switch (index) {
			case '集团账号':
				str = 'memberAccountRef'
				break;
			case '服务站':
				str = 'serviceStationRef'
				break;
			case '资源库':
				str = 'resourcePageRef'
				break;
			case '工具箱':
				str = 'toolRef'
				break;
			case 'icon-xcx1024@2x':
				str = 'mobileRef'
				break;
			case 'icon-notice1024@2x':
				str = 'mailRef'
				break;
			case 'icon-setting1024@2x':
				str = 'noticeRef'
				break;
			default:
				break;
		}
		return str
	}

	// 点击后清除搜索项内容
	function clearMethods() {
		headerSearchVal.value = ''
		isSearchShow.value = false
		isHover.value = false
		searchData.value = []
	}

	// 点击全部清除
	function clearHandle(type) {
		proxy.$refs.headerSearchValRef.focus()
		isClear.value = true
		// console.log(isClear.value, 'isClear.value')
		// if (type === 'visit') {
		// 	// 无数据时禁用
		// 	if (searchVisitData.value.length === 0) {
		// 		return
		// 	}

		// 	// 清除最近访问
		// 	homesearchRemoveAllApi(2)
		// } else if (type === 'history') {
		// 	// 无数据时禁用
		// 	if (searchHistoryData.value.length === 0) {
		// 		return
		// 	}

		// 	// 清除搜索历史
		// 	homesearchRemoveAllApi(1)
		// }

		// 20250917 改为同时清除搜索历史及最近访问
		// 都无数据时禁用
		if (searchVisitData.value.length === 0 && searchHistoryData.value.length === 0) {
			return
		}

		// 清除搜索历史
		homesearchRemoveAllApi(1)
		// 清除最近访问
		homesearchRemoveAllApi(2)
	}

	// 输入框获取焦点
	function focusHandle() {
		useUserStore().isMenu = false
		useUserStore().isHover = false

		// console.log(headerSearchVal.value, 'headerSearchVal.value')
		if (headerSearchVal.value) {
			isSearchShow.value = true
			isHover.value = false

			// console.log(isSearchShow.value, isHover.value, 'focusHandle')
		} else {
			isSearchShow.value = false
			isHover.value = true

			// 查询搜索历史和最近访问 1搜索历史，2最近访问
			homesearchListApi(1)
			homesearchListApi(2)
		}
	}

	// 获取搜索框弹窗 自适应位置
	function getSearchHoverLeft() {
		setTimeout(() => {
			searchHoverLeft.value = document.documentElement.clientWidth - proxy.$refs.headerSearchBloRef
				.offsetLeft - 664
			// console.log(document.documentElement.clientWidth, proxy.$refs.headerSearchBloRef.offsetLeft,
			// 	searchHoverLeft.value, 'searchHoverLeft.value')
		}, 20)
	}

	// 清除搜索历史和最近访问 1搜索历史，2最近访问
	function homesearchRemoveAllApi(type) {
		homesearchRemoveAll({
			type
		}).then(res => {
			if (res) {
				// if (type === 1) {
				// 	searchHistoryData.value = []
				// } else {
				// 	searchVisitData.value = []
				// }

				// 20250917 改为同时清除搜索历史及最近访问
				homesearchListApi(1)
				homesearchListApi(2)
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 查询搜索历史和最近访问 1搜索历史，2最近访问
	function homesearchListApi(type) {
		// 获取搜索框弹窗 自适应位置
		getSearchHoverLeft()

		homesearchList({
			type
		}).then(res => {
			if (res) {
				let data = res.data
				if (type === 1) {
					searchHistoryData.value = data
				} else {
					searchVisitData.value = data
				}
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 输入框失去焦点
	function blurHandle() {
		setTimeout(() => {
			// console.log(isSearchShow.value, isHover.value, isClear.value, 'blurHandle')
			// 不是清除并且不是点击切换项
			if (!isClear.value && !isTab.value) {
				isHover.value = false
				isSearchShow.value = false
				// 点击后清除搜索项内容
				clearMethods()
			}

			// 点击清除时
			if (isClear.value) {
				isClear.value = false
				// 调用添加搜索历史接口（输入框焦点移出时记录输入框内容）
			}
		}, 330)
	}

	const timeout = ref(null)
	// 搜索(防抖)
	function inputHandle(isNot) {
		// 获取搜索框弹窗 自适应位置
		getSearchHoverLeft()

		if (isNot) {
			// 调用搜索接口
			homeSearchSearchApi()
		} else {
			// 防抖
			clearTimeout(timeout.value)
			timeout.value = setTimeout(() => {
				// 调用搜索接口
				homeSearchSearchApi()
			}, 550)
		}
	}

	// 调用搜索接口
	function homeSearchSearchApi() {
		if (headerSearchVal.value) {
			homeSearchSearch({
				keyword: headerSearchVal.value
			}).then(res => {
				if (res) {
					let data = res.data
					isSearchShow.value = true
					isHover.value = false
					searchData.value = data.list
					searchDataIndex.value = null
					allNum.value = data.total

					homesearchListApi(1)
				}
			}).catch(e => {
				setMessageQueue('error', e)
				console.log(e)
			})

		} else {
			isSearchShow.value = false
			isHover.value = true
		}
	}

	// 回车提交指令
	function enterHandle() {
		console.log('enterHandle input keyup.enter回车提交指令调用')
		// 1公版无法指定，禁用指令输入 20260324 解除当前公版无法在项目首页输入指令的限制
		// if (isHavePerssion.value) {
		// 	return
		// }

		if (!headerSearchVal.value) {
			// 无指令时 给提示
			setMessageQueue('info', '当前暂无此指令，请重新输入')
			return
		} else {
			// 执行指令
			homeSearchCheckSearchApi()
		}
	}

	// 执行指令
	function homeSearchCheckSearchApi() {
		homeSearchCheckSearch({
			key: headerSearchVal.value
		}).then(res => {
			if (res && res.code === 200) {
				if (headerSearchVal.value === 'cmd terminal' || headerSearchVal.value === 'ter') {
					// 重置
					resetMethods()
					// 打开终端页
					router.push('/terminalPage')
				} else if (headerSearchVal.value === 'cmd exit' || headerSearchVal.value === 'exit') {
					// 强制退出当前账号 并清除登录缓存
					setMessageQueue('success', res.data || '已生效「自动下线」指令')
					// 重置
					resetMethods()
					setTimeout(() => {
						// 手动调用退出登录
						sureHandle()
					}, 1000)
				} else if (headerSearchVal.value === 'cmd all inn') {
					isExecute.value = true
					headerSearchVal.value = '指令手册'
					setMessageQueue('success', '已生效「展开全部指令」')

					// 调用搜索接口
					homeSearchSearchApi()
					// 获取指令手册数据
					cmdcommandListApi()
					// // 跳转到指令手册页
					// router.push('/instructionManual')
				} else {
					// 重置
					resetMethods()
					setMessageQueue('success', res.data || '指令执行成功')
				}
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 获取指令手册数据
	function cmdcommandListApi() {
		cmdcommandList({
			limit: 100,
			page: 1,
			keyword: ''
		}).then(res => {
			if (res) {
				const data = res.data.list
				let arr = []
				data.map(item => {
					if (item.instructionCode !== 'cmd all inn') {
						if (item.instructionCode.includes('(')) {
							let index = item.instructionCode.indexOf('(')
							item.instructionCode = item.instructionCode.substring(0, index) + '*'
						}

						arr.push(item)
					}
				})

				cmdcommandData.value = arr
				// console.log(cmdcommandData.value, 'cmdcommandData.value')
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 重置
	function resetMethods() {
		isSearchShow.value = false
		isHover.value = false
		headerSearchVal.value = ''

		// 使当前聚焦的元素失去焦点
		if (document.activeElement) {
			document.activeElement.blur();
		}
	}

	// 点击站内信查看更多
	function showMoreHandle(item) {
		// 20260921新增
		localStorage.removeItem('noticeDrawerShow')
		noticeDrawerShow.value = false
		useUserStore().isMenu = false
		useUserStore().isHover = false

		if (item) {
			router.push('/mailDetailsPage?id=' + (item ? item.id : '') + '&stationLetterId=' + item.stationLetterId +
				'&pageType=nav')
		} else {
			router.push('/mailPage')
		}
	}

	// 点击全部已读
	function allReadHandle() {
		if (noticeData.value.length === 0) {
			setMessageQueue('warning', '当前暂无数据')
			return
		}
		sysnoticestationletterstatusReadAll().then(res => {
			if (res) {
				setMessageQueue('success', '全部已读成功')
				// 刷新站内信
				sysnoticestationletterListApi()
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 点击标为已读
	function markHandle(item) {
		sysnoticestationletterReadLetter({
			ids: [item.id]
		}).then(res => {
			if (res) {
				setMessageQueue('success', '已读成功')
				// 刷新站内信
				sysnoticestationletterListApi()
			}
		}).catch(e => {
			if (e.includes('不存在')) {
				// 20260921 新增刷新站内信
				sysnoticestationletterListApi()
			}

			setMessageQueue('error', e)
			console.log(e)
		})
	}

	const noticeMouseoverIndex = ref(null) // 站内信鼠标悬浮索引

	// 站内信鼠标悬浮
	function noticeMouseover(index) {
		noticeMouseoverIndex.value = index
		// 重置
		mouseoverIndex.value = null
	}

	// 站内信鼠标离开
	function noticeMouseleave() {
		noticeMouseoverIndex.value = null
	}

	// 点击站内信tab
	function noticeTabsHandle(key) {
		noticeTabKey.value = key
		// 获取站内信
		sysnoticestationletterListApi()
	}

	// 点击设置主题色/阅读模式/快捷键/侧边栏
	function settingHandle(val, type) {
		if (type === 'theme') {
			if (userConfigData.value.theme === val) {
				return
			}
			if (val !== 'dark') {
				setMessageQueue('info', '页面待开发，二期计划')
				return
			}
		} else if (type === 'shortcutKey') {
			console.log(val)
		} else if (type === 'sideModel') {
			if (userConfigData.value.sideModel === val) {
				return
			}
			userConfigData.value.sideModel = val
		} else {
			if (userConfigData.value.readModel === val) {
				return
			}
			userConfigData.value.readModel = val
		}

		// 修改自定义配置接口
		configuserpersonalizedUpdateApi(type, val)
	}

	// 修改自定义配置接口
	function configuserpersonalizedUpdateApi(type, val) {
		let params = {
			...userConfigData.value
		}
		if (type === 'theme') {
			params.theme = val
		}

		configuserpersonalizedUpdate(params).then(res => {
			if (res) {
				if (type === 'theme') {
					userConfigData.value.theme = val
					useUserStore().theme = val
					initTheme(theme.value)
				}

				// 获取当前账号默认配置（自定义配置等）
				useUserStore().configuserpersonalizedInfoApi()
				// 获取当前账号最新信息
				useUserStore().getInfoApi()
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 优化点击弹窗内容也会关闭弹窗问题
	function stopHandle() {}

	// 点击后指令赋值到快捷输入框内
	function cmdcommandHandle(code) {
		headerSearchVal.value = code
		isTab.value = true
		// 输入框获取焦点
		setTimeout(() => {
			proxy.$refs.headerSearchValRef.focus()
		})
	}

	// 点击跳转页面
	async function jumpUrlHandle(path, type, refs, item) {
		// 未登录时点击无反应
		if (!isLogin.value) {
			return
		}
		// 点击站内信/自定义配置
		if (type === '2') {
			let left = proxy.$refs[refs][0].offsetLeft
			let innerWidth = window.innerWidth
			let mailWidth = 388
			let str = ''

			if (left) {
				if (innerWidth - left > mailWidth) {
					mailLeft.value = left
				} else {
					mailLeft.value = innerWidth - left - mailWidth
				}
			}
			// console.log(mailLeft.value, left, 'mailRef')

			if (path === 'noticeDrawerShow') {
				if (settingDrawerShow.value) {
					settingDrawerShow.value = false

					setTimeout(() => {
						noticeDrawerShow.value = !noticeDrawerShow.value
						// 20260921新增
						localStorage.setItem('noticeDrawerShow', noticeDrawerShow.value)
					}, 300)
				} else {
					noticeDrawerShow.value = !noticeDrawerShow.value
					// 20260921新增
					localStorage.setItem('noticeDrawerShow', noticeDrawerShow.value)
				}

				if (noticeDrawerShow.value) {
					// 获取站内信
					sysnoticestationletterListApi()
				}
			} else if (path === 'settingDrawerShow') {
				if (noticeDrawerShow.value) {
					noticeDrawerShow.value = false
					// 20260921新增
					localStorage.setItem('noticeDrawerShow', noticeDrawerShow.value)

					setTimeout(() => {
						settingDrawerShow.value = !settingDrawerShow.value
						// 20260921新增
						localStorage.setItem('noticeDrawerShow', noticeDrawerShow.value)
					}, 300)
				} else {
					settingDrawerShow.value = !settingDrawerShow.value
					// 20260921新增
					localStorage.setItem('noticeDrawerShow', noticeDrawerShow.value)
				}
			}

			useUserStore().isMenu = false
			useUserStore().isHover = false

			proxy.$emit('clickHandle', {
				noticeDrawerShow: noticeDrawerShow.value,
				settingDrawerShow: settingDrawerShow.value,
			})
		} else {

			// 新增只要点击非站内信/自定义配置部分 即关闭弹窗
			if (settingDrawerShow.value) {
				settingDrawerShow.value = false
			}

			if (noticeDrawerShow.value) {
				noticeDrawerShow.value = false
				// 20260921新增
				localStorage.removeItem('noticeDrawerShow')
			}

			// 点首页
			if (path === '/') {
				// 跳转首页
				jumpDashboardHandle(path)
			} else {
				// 获取菜单权限（非首页）
				getPermissionHandle(path, type, refs, item)
			}
		}
	}

	// 获取菜单权限
	async function getPermissionHandle(path, type, refs, item) {
		// console.log(item, 'itemitem')
		// 档案类别等二级菜单不跳转
		if (item && item.type === 2) {
			return
		}

		// 定制路径跳转（不校验权限）
		if (item && item.parentId === -2) {
			window.open(path)
			return
		}

		// 使用帮助-更新日志 跳转新页（云联智办OFC预览页）
		if (item && item.url === '/updateExplanation') {
			window.open(jumpOpenUrl.value + 'ofc9')
			return
		}

		const data = await sysmenupowerPowerInApi(path)
		if (data.code === 200) {
			// 点击资源库不跳转
			if (path === '//') {
				if (item.name === '共享打印') {
					// 1公版时提示
					if (isHavePerssion.value) {
						setMessageQueue('warning', '请联系五十三线上服务站进行配置')
						return

					} else {
						// 内测时 调用打印提示弹窗--公共方法
						isPrintMethods()
					}
				}
				return
			} else if (path === '///') {
				// 跳转测试环境 可以实现传参 window.open(trackLink, token)  接参console.log(window.name);
				return
				window.open(isDev.value ? defaultSettings.serviceDevLink : defaultSettings.serviceLink)

			}
			// 跳转页面关闭侧边导航栏
			if (type === '3') {
				useUserStore().isMenu = false
				useUserStore().isHover = false
			}
			mouseoverIndex.value = null

			// 非管理员 权限不足提示
			// if (path === 'operationLog' && !isGetPermission()) {
			// 	setMessageQueue('warning', '权限组不满足，无法操作')
			// 	return
			// }
			if (path === 'operationLog') {
				const data = await getNotEditableShow('', '', 1)
				if (data.code === 505) {
					return
				}
			}

			useUserStore().isMenu = false
			useUserStore().isHover = false

			// 获取动态左侧菜单+标题（公共方法） 20250805 新增
			getLeftMenuListDataCommon(path)
			router.push(path)

			isExecute.value = false
			// 跳转页面后--失去焦点--搜索弹窗关闭
			isTab.value = false
			blurHandle()
		}
	}

	// 获取动态左侧菜单+标题（公共方法） 20250731 新增
	function getLeftMenuListDataCommon(menuUrl) {
		const arrNum = ['0', '1', '2', '3', '4', '5']
		if (JSON.stringify(sidebarObj.value) === '{}') {
			if (menuUrl) {
				useUserStore().defaultOpeneds = arrNum
				// 获取动态左侧菜单+标题
				getLeftMenuListData(menuUrl)
			}
		} else {
			if (sidebarData.value.length > 0) {
				let num = 0
				sidebarData.value.map(item => {
					if (item.path === menuUrl) {
						num++
					}

					if (item.children && item.children.length > 0) {
						item.children.map(items => {
							if (items.path === menuUrl) {
								num++
							}
						})
					}
				})
				// console.log(num, 'numnumnumnumnum')
				if (num === 0) {
					useUserStore().defaultOpeneds = arrNum
					// 获取动态左侧菜单+标题
					getLeftMenuListData(menuUrl)
				}
			}
		}
	}

	// 获取动态左侧菜单+标题
	async function getLeftMenuListData(menuUrl) {
		const res = await getLeftMenuList(menuUrl)
		if (res) {
			const data = res.data
			if (data) {
				useUserStore().sidebarObj = data
			}
		}
	}

	// 公共方法
	function isPrintMethods() {
		if (!useUserStore().isPrintShow) {
			useUserStore().isPrintShow = true
			useUserStore().countdown = 9
		}

		mouseoverIndex.value = null
	}

	// 获取站内信
	function sysnoticestationletterListApi() {
		sysnoticestationletterList({
			page: 1,
			limit: 15,
			readSort: '', // 当值为noRead时表示未读置顶，空或者其他值是否已读状态不参与排序
			timeSort: 'desc', // 为空或者desc时，根据接收时间倒序排序
			typeId: typeId.value,
			title: '',
			status: noticeTabKey.value // 阅读状态，1阅读，0未读，空则全部
		}).then(res => {
			if (res) {
				let data = res.data
				noticeData.value = data.list
				// 获取站内信--未读条数
				useUserStore().sysnoticestationletterUserStationLetterNumApi()
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 鼠标悬浮 tab+avatar
	function mouseover(index, type, refs, width) {
		// console.log(index, type, refs, width, 'index, type, refs, width')
		// 重置悬浮状态
		if (type === 'noHover') {
			mouseoverIndex.value = null
			// console.log(mouseoverIndex.value, type, 'mouseover')
			return
		}
		if (index === 'avatar' && !isLogin.value) {
			return
		}

		if (refs) {
			let left = proxy.$refs[refs][0].offsetLeft
			let innerWidth = document.documentElement.clientWidth
			// window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;  // innerWidth包括滚动条 clientWidth 不包括滚动条
			let str = ''

			if (left) {
				hoverCardLeft.value = null
				// console.log(innerWidth, left, width, innerWidth - left <= width, 'innerWidth, left, width')
				if (innerWidth - left <= width) {
					hoverCardLeft.value = innerWidth - left - width
				} else {
					// hoverCardLeft.value = width - (innerWidth - left)
				}
			}
			// console.log(hoverCardLeft.value, left, 'hoverCardLeft')
		}
		mouseoverIndex.value = index
	}

	// 鼠标离开
	function mouseleave() {
		mouseoverIndex.value = null
	}

	// 点击退出登录
	function logoutHandle() {
		logoutModal.value = true
		// console.log(logoutModal, 'logoutModal')
	}

	// 点击确认
	function sureHandle() {
		// 20260302 新增 报错时重置loading状态 报错时true/false提交时
		loadingReset.value = false
		setTimeout(() => {
			loadingReset.value = true
		}, 500)

		// 退出登录并且关闭退出弹窗
		logoutModal.value = resetLogin('logout')
	}

	// 点击取消
	function cancelHandle() {
		logoutModal.value = false
		settingDrawerShow.value = false
		noticeDrawerShow.value = false
		localStorage.removeItem('noticeDrawerShow')
		// console.log(logoutModal.value, 'cancelHandle')
	}

	// 点击展开菜单
	function isMenuHandle() {
		useUserStore().isMenu = !useUserStore().isMenu
		// console.log(isMenuHover.value, useUserStore().isMenu, 'isMenuHover isMenu')
		if (useUserStore().isMenu) {
			// 获取菜单数据接口
			getMenuDataApi()
		}
	}

	const setTimeoutTime = ref(null)
	// 悬浮遮罩层
	function isMenuHoverHandle() {
		// 清除导航栏图标悬浮显示延时器
		clearTimeoutTime()

		setTimeoutTime.value = setTimeout(() => {
			useUserStore().isMenu = true
			isMenuHover.value = true

			if (useUserStore().isMenu) {
				// 获取菜单数据接口
				getMenuDataApi()
				// 20260415 新增
				// 获取全部的收藏的菜单
				useUserStore().corecollectListAllApi()
			}
		}, 300)
	}

	// 离开导航图标
	function isMenuMouseHandle() {
		isMenuHover.value = false

		// 清除导航栏图标悬浮显示延时器
		clearTimeoutTime()
	}

	// 点击收藏
	function collectHandle(index, name, items) {
		if (collectData.value.length === 10) {
			setMessageQueue('warning', '收藏数量已满，请自行替换。', 'click收藏数量已满，请自行替换。')
			return
		}

		useUserStore().collectData.push(items)
		let data = menuData.value[menuDataIndex.value].children
		if (data && data.length > 0) {
			// 其他功能点击收藏时
			let childIndex = data.findIndex(val => {
				return val.id === items.id && val.parentId === items.parentId
			})
			if (childIndex > -1) {
				data[childIndex].collect = true
			}

			items.collect = true
			// console.log(menuData.value, 'menuData.valuemenuData.value')
		} else {
			// 全部功能点击收藏时
			let allData = []
			let parIndex = menuData.value.findIndex(val => {
				return val.name === name
			})
			if (parIndex > -1) {
				allData = menuData.value[parIndex].children

				let childIndex = allData.findIndex(val => {
					return val.id === items.id && val.parentId === items.parentId
				})

				if (childIndex > -1) {
					allData[childIndex].collect = true
				}
			}

			items.collect = true
		}

		// console.log(menuData.value, 'menuData.value')
		// if (name) {
		// 	items.collect = true
		// 	useUserStore().collectData.push(items)
		// } else {
		// 	obj = centerMenuData.value.children[index]
		// 	obj.collect = true
		// 	useUserStore().collectData.push(obj)
		// }
		// console.log(centerMenuData.value, 'centerMenuData.value')
		collectMenuShow.value = true
		// 收藏接口
		corecollectCollectOrCancelApi(items)
	}

	// 收藏/取消收藏接口
	function corecollectCollectOrCancelApi(item) {
		// console.log(item.id, 'id')
		corecollectCollectOrCancel({
			menuId: item.id,
			type: item.parentId === -2 ? 1 : 2 // 定制路径传1，正常菜单传2
		}).then(res => {
			if (res) {
				// 获取全部的收藏的菜单
				useUserStore().corecollectListAllApi()
				// console.log(res.data, 'res.data')
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 取消收藏
	function removeCollectHandle(index, name, type, items) {
		// console.log(items, 'removeCollectHandle')
		// 点击收藏图标
		if (type) {
			let data = menuData.value[menuDataIndex.value].children
			if (data && data.length > 0) {
				// 其他功能点击收藏时
				let childIndex = data.findIndex(val => {
					return val.id === items.id && val.parentId === items.parentId
				})
				if (childIndex > -1) {
					data[childIndex].collect = false
				}
				items.collect = false
				// console.log(menuData.value, 'menuData.value')
			} else {
				// 全部功能点击收藏时
				let allData = []
				let parIndex = menuData.value.findIndex(val => {
					return val.name === name
				})
				if (parIndex > -1) {
					allData = menuData.value[parIndex].children

					let childIndex = allData.findIndex(val => {
						return val.id === items.id && val.parentId === items.parentId
					})

					if (childIndex > -1) {
						allData[childIndex].collect = false
					}
				}

				items.collect = false
			}


			let collectIndex = collectData.value.findIndex(val => {
				return val.id === items.id && val.parentId === items.parentId
			})
			if (collectIndex > -1) {
				useUserStore().collectData.splice(collectIndex, 1)
			}
		} else {
			// 点击已收藏功能x
			useUserStore().collectData.splice(index, 1)

			let collectIndex
			// 其他功能 
			let obj = centerMenuData.value.children
			if (obj && obj.length > 0) {
				// console.log(centerMenuData.value.children, 'centerMenuData.value.children')
				collectIndex = obj.findIndex(val => {
					return items.parentId === val.parentId && val.id === items.id
				})
				if (collectIndex > -1) {
					obj[collectIndex].collect = false
				}
			}

			// 全部功能
			cardList1.value.map(item => {
				if (item.children && item.children.length > 0) {
					item.children.map(val => {
						if (items.parentId === val.parentId && val.id === items.id) {
							val.collect = false
						}
					})
				}
			})
			cardList2.value.map(item => {
				if (item.children && item.children.length > 0) {
					item.children.map(val => {
						if (items.parentId === val.parentId && val.id === items.id) {
							val.collect = false
						}
					})
				}
			})
			cardList3.value.map(item => {
				if (item.children && item.children.length > 0) {
					item.children.map(val => {
						if (items.parentId === val.parentId && val.id === items.id) {
							val.collect = false
						}
					})
				}
			})

			// 定制路径
			menuData.value.map(item => {
				if (item.children && item.children.length > 0) {
					item.children.map(val => {
						if (items.id === val.id && items.parentId === val.parentId) {
							// console.log(items.id, items.id === val.id && items.parentId === val.parentId,
							// 	'items.id === val.id && items.parentId === val.parentId')
							val.collect = false
						}
					})
				}
			})

			// 获取定制路径数据
			getPathArr(pathIndex.value)
		}

		// 取消收藏接口
		corecollectCollectOrCancelApi(items)
	}

	// 关闭菜单
	function closeMenuHandle() {
		collectMenuShow.value = false
	}

	// 点击菜单
	function menuDataHandle(index, name) {
		menuDataIndex.value = index
		// 获取最新菜单展示数据
		getCenterMenuData(index, name)
	}

	// 获取菜单数据接口
	function getMenuDataApi() {
		sysSysmenuNav().then(res => {
			if (res) {
				const data = res.data
				menuData.value = data
				total.value = res.num

				useUserStore().leftMenuData = data
				localStorage.setItem('leftMenuData', JSON.stringify(data))

				// 获取最新菜单展示数据
				getCenterMenuData(menuDataIndex.value)

				let index = menuData.value.findIndex(val => {
					return val.name === '定制路径'
				})

				if (index > -1) {
					// 定制路径索引
					pathIndex.value = index
					// 获取定制路径数据
					getPathArr(index)
				}
			}
		})
	}

	// 获取最新菜单展示数据
	function getCenterMenuData(index, name) {
		let arr = JSON.parse(JSON.stringify(menuData.value))
		arr.splice(0, 1)
		let newArr = index === 0 ? arr : menuData.value[index]
		if (index === 0) {
			cardList1.value = []
			cardList2.value = []
			cardList3.value = []
			// 平分数据，确保页面上遍历卡片dom的真实顺序与平分的一致 document.querySelectorAll('.card-item'))
			let num = parseInt(newArr.length / 3)
			// 全部功能
			newArr.forEach((item, i) => {
				if (i % 3 === 0) {
					cardList1.value.push(item)
					return
				}
				if (i % 3 === 1) {
					cardList2.value.push(item)
					return
				}
				cardList3.value.push(item)
			})
		} else {
			if (index === pathIndex.value) {
				// 获取定制路径数据
				getPathArr(index)
			} else {
				centerMenuData.value = newArr
			}
		}
	}

	// 获取定制路径数据
	function getPathArr(index) {
		let children = JSON.parse(JSON.stringify(menuData.value))[index].children
		let newChildrenArr = [{
				children: []
			},
			{
				children: []
			},
			{
				children: []
			},
			{
				children: []
			}
		]
		let num = 0
		if (children && children.length > 0) {
			children.map(item => {
				if (!item.id) {
					num++
				}
				if (num < 2) {
					newChildrenArr[0].children.push(item)
					newChildrenArr[0].name = '定制路径'
					// console.log(newChildrenArr[0].children, item, 'ppp')
				} else {
					newChildrenArr[num - 1].name = ''
					newChildrenArr[num - 1].children.push(item)
				}
				// console.log(item, 'itemitemitemitem')
			})
		}

		let data = []
		newChildrenArr.map(item => {
			if (item.children && item.children.length > 0) {
				data.push(item)
			}
		})
		centerMenuChildrenData.value = data
		// console.log(centerMenuChildrenData.value, 'newChildrenArr')
	}

	// 点击回车键
	function keyDown(e) {
		console.log(e, 'e keyDown document.activeElement', document.activeElement, useUserStore().isModal)

		// 弹窗显示 键盘快捷键强制失效
		if (useUserStore().isModal) {
			return
		}

		console.log('仅为使用快捷键/', e.keyCode === 191 && document.activeElement.tagName === 'BODY' && !useUserStore().isModal,
			e, document.activeElement, useUserStore().isModal);
		// /键的ASCII是191 当焦点不属于输入状态时，恢复/快捷键功能。
		if (e.keyCode === 191 && document.activeElement.tagName === 'BODY' && !useUserStore().isModal) {
			setTimeout(() => {
				proxy.$refs.headerSearchValRef.focus()
			})
		}
	}

	// 获取消息类型
	function sysnoticestationlettertypeListAllApi() {
		sysnoticestationlettertypeListAll().then(res => {
			if (res) {
				let data = res.data
				typeIdData.value = data
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 获取当前账号默认配置（自定义配置等）
	function configuserpersonalizedInfoApi() {
		configuserpersonalizedInfo().then(res => {
			if (res) {
				userConfigData.value = res.data || {
					theme: 'dark',
					readModel: 'inside'
				}
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 初始化方法
	function initMethods() {
		// 重置弹窗状态
		useUserStore().isModal = false
		// 获取用户信息
		useUserStore().getInfoApi().then(res => {
			if (res) {
				// 获取菜单数据接口(保证初始化调用时 获取用户信息后调用)
				getMenuDataApi()
				// 20260415 新增
				// 获取全部的收藏的菜单
				useUserStore().corecollectListAllApi()
				// 获取是否有获取平台消息菜单权限
				useUserStore().sysnoticeconfigPlatformShowmApi()
			}
		}).catch(error => {
			console.log(error, 'error')
		})
		// 获取消息类型
		sysnoticestationlettertypeListAllApi()

		clearInterval(setIntervalTime.value)
		setIntervalTime.value = null

		// 服务站--待处理数量
		useUserStore().sysnoticeservicestationTopNuminfoApi()
		// 获取站内信--未读条数
		useUserStore().sysnoticestationletterUserStationLetterNumApi()
		// 获取设备审核中数量
		useUserStore().archivedeviceapplyApprovalNumApi()

		// 获取顶部导航栏动态数据
		useUserStore().sysmenupowerDynamicMenuApi().then((res) => {
			if (res) {
				// 重新加载 监听浏览器变化
				resizeHandlerNav()
			}
		})

		setIntervalTime.value = setInterval(() => {
			if (localStorage.getItem('token')) {
				// // 服务站--待处理数量
				// useUserStore().sysnoticeservicestationTopNuminfoApi()
				// // 获取站内信--未读条数
				// useUserStore().sysnoticestationletterUserStationLetterNumApi()
				// // 获取设备审核中数量
				// useUserStore().archivedeviceapplyApprovalNumApi()
			} else {
				clearInterval(setIntervalTime.value)
				setIntervalTime.value = null

				// 服务站--待处理数量
				useUserStore().servicesTopNumData = 0
				// 获取站内信--未读条数
				useUserStore().noRead = 0
				// 获取设备审核中数量
				useUserStore().approvalNum = 0
			}
		}, 5000)

		// 获取全部的收藏的菜单
		useUserStore().corecollectListAllApi()
		// 获取当前账号默认配置（自定义配置等）
		useUserStore().configuserpersonalizedInfoApi()
	}

	const timeOut = ref(null)
	const isHideText = ref(false)
	const isHideTextSmall = ref(false)
	// 监听浏览器变化
	function resizeHandlerNav() {
		clearTimeout(timeOut.value)
		timeOut.value = setTimeout(() => {
			// 根据屏幕尺寸隐藏
			getWindowHide()

			// 重置站内信及自定义配置弹窗显示状态
			// settingDrawerShow.value = false
			// noticeDrawerShow.value = false

			// //
			// let left = proxy.$refs[refs][0].offsetLeft
			// let innerWidth = window.innerWidth
			// let mailWidth = 388
			// let str = ''

			// if (left) {
			// 	if (innerWidth - left > mailWidth) {
			// 		mailLeft.value = left
			// 	} else {
			// 		mailLeft.value = innerWidth - left - mailWidth
			// 	}
			// }
		}, 20)

		// 获取搜索框弹窗 自适应位置
		getSearchHoverLeft()
	}

	const isSmallSize = ref(false) // 小尺寸
	// 根据屏幕尺寸隐藏
	function getWindowHide() {
		// 根据导航栏展示项 动态匹配宽度
		// console.log(navMenuData.value, window.innerWidth, 'navMenuData.value')

		let len = navMenuData.value.length
		let isHideWid = switchIsHideWid(len)
		let isHideSmallWid = switchIsHideSmallWid(len)
		let isSmallWid = switchIsSmallWid(len)

		if (window.innerWidth <= isHideWid) {
			isHideText.value = true

			// console.log(window.innerWidth <= isHideSmallWid)
			if (window.innerWidth <= isHideSmallWid) {
				isHideTextSmall.value = true
			} else {
				isHideTextSmall.value = false
			}

			if (window.innerWidth <= isSmallWid) {
				isSmallSize.value = true

				// // 新增搜索框弹窗自适应
				// searchHoverLeft.value = window.innerWidth - proxy.$refs.headerSearchBloRef.offsetLeft - 664
			} else {
				isSmallSize.value = false
				// searchHoverLeft.value = null
			}
		} else {
			isHideText.value = false
			isHideTextSmall.value = false
			isSmallSize.value = false
		}
		// console.log(window.innerWidth, isHideTextSmall.value, 'ppp')
	}

	// 浏览器自适应后 间距paddingLR16取消
	function switchIsHideWid(len) {
		let str = null
		switch (len) {
			case 4:
				str = 1440
				break;
			case 3:
				str = 1328
				break;
			case 2:
				str = 1290
				break;
			case 1:
				str = 1164
				break;
			default:
				break;
		}
		return str
	}

	// 浏览器自适应后 名称换成icon
	function switchIsHideSmallWid(len) {
		let str = null
		switch (len) {
			case 4:
				str = 1200
				break;
			case 3:
				str = 1120
				break;
			case 2:
				str = 1078
				break;
			case 1:
				str = 992
				break;
			default:
				break;
		}
		return str
	}

	// 浏览器自适应后 动态导航栏和运维中心icon隐藏
	function switchIsSmallWid(len) {
		let str = null
		switch (len) {
			case 4:
				str = 1104
				break;
			case 3:
				str = 1032
				break;
			case 2:
				str = 1004
				break;
			case 1:
				str = 932
				break;
			default:
				break;
		}
		return str
	}

	// 清除导航栏图标悬浮显示延时器
	function clearTimeoutTime() {
		clearTimeout(setTimeoutTime.value)
		setTimeoutTime.value = null
	}

	// 20260408 新增检测账号切换弹窗（不同账号/退出登录）
	const showLogoutModalShow = ref(false)
	const showLogoutModalTime = ref(null)
	const showLogoutNum = ref(5)
	// 利用浏览器的visibilitychange事件，页面可见时，查询最新的缓存信息
	function visibilitychangeHandle() {
		// 20260409补充 有弹窗后并且强刷页面时 用记录缓存的方式回到首页
		if (sessionStorage.getItem('showLogoutModalShow')) {
			// 关闭弹窗并跳转到首页
			showLogoutModalHandle()
		}

		document.addEventListener('visibilitychange', () => {
			if (document.visibilityState === 'visible') {
				const userInfoOld = useUserStore().userConfigData
				console.log(useUserStore().userConfigData, userInfoOld, '页面可见，执行恢复操作 旧数据');

				// 如果是退出登录 手动调用接口 强制下线
				if (localStorage.getItem('isLogout') === '1') {
					useUserStore().getInfoApi()
					return
				}

				// 每次切页面回来 都查一遍最新的缓存数据（自定义配置）
				useUserStore().loadUserConfigDataStorage();
				// 每次切页面回来 都查一遍最新的缓存数据（用户信息）
				useUserStore().loadUserInfoStorage();
				// 每次切页面回来 都查一遍最新的缓存数据（未读站内信数量）
				useUserStore().loadNoReadStorage();
				// 每次切页面回来 都查一遍最新的缓存数据（服务站--待处理数量）
				useUserStore().loadServicesTopNumDataStorage();
				// 每次切页面回来 都查一遍最新的缓存数据（设备审核中数量）
				useUserStore().loadApprovalNumStorage();

				if (userInfoOld.userId !== useUserStore().userConfigData.userId) {
					console.log(useUserStore().userConfigData, useUserStore().userInfo, userInfoOld.id !==
						useUserStore().userInfo.id, '页面可见，执行恢复操作 新数据');
					console.log('切换账号弹窗显示')
					showLogoutModalShow.value = true

					// 20260409补充 有弹窗后并且强刷页面时 用记录缓存的方式回到首页
					sessionStorage.setItem('showLogoutModalShow', 1)

					// 20260610补充 有弹窗后直接清除新账号对应的缓存 防止停留在旧帐号的数据中
					console.log(localStorage.getItem('token'), 'cacheDeleteCacheByTokenApi')
					if (localStorage.getItem('token')) {
						cacheDeleteCacheByTokenApi()
					}

					showLogoutNum.value = 5
					if (showLogoutModalTime.value) clearInterval(showLogoutModalTime.value);

					showLogoutModalTime.value = setInterval(() => {
						showLogoutNum.value--

						if (showLogoutNum.value === 0) {
							// 关闭弹窗并跳转到首页
							showLogoutModalHandle()
						}
					}, 1000)

					return
				}
			} else {
				// 20260603补充 有过弹窗并且关掉当前页签 直接清掉弹窗缓存并且跳转至首页
				if (sessionStorage.getItem('showLogoutModalShow')) {
					// 关闭弹窗并跳转到首页
					showLogoutModalHandle()
				}

				console.log('页面隐藏，暂停后台任务');
			}
		});
	}

	// 20260610补充 有弹窗后直接清除新账号对应的缓存 防止停留在旧帐号的数据中
	function cacheDeleteCacheByTokenApi() {
		cacheDeleteCacheByToken({
			token: localStorage.getItem('token')
		}).then(res => {
			if (res) {
				console.log('cacheDeleteCacheByToken')
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 关闭弹窗并跳转到首页
	function showLogoutModalHandle() {
		clearInterval(showLogoutModalTime.value)
		showLogoutModalTime.value = null
		showLogoutModalShow.value = false
		// 20260409补充 有弹窗后并且强刷页面时 用记录缓存的方式回到首页
		sessionStorage.removeItem('showLogoutModalShow')
		// 跳转首页
		jumpDashboardHandle('/')
	}

	// 跳转首页
	function jumpDashboardHandle(path) {
		useUserStore().isRefreshDashboard = true
		useUserStore().defaultOpeneds = ['0', '1', '2', '3', '4', '5']
		setTimeout(() => {
			useUserStore().isRefreshDashboard = false
		}, 200)

		useUserStore().isMenu = false
		useUserStore().isHover = false
		useUserStore().getInfoApi()
		useUserStore().configuserpersonalizedInfoApi()
		isExecute.value = false

		router.push(path)
	}

	const time = ref(null)
	onMounted(() => {
		var params = new URLSearchParams(window.location.search)
		const ticket = params.get('token') // 获取最新的口令
		const wxCode = params.get('code') // 20260611 新增优化

		// 待添加有token后可调用
		if (localStorage.getItem('token')) {
			// 20251128 新增特殊处理 有ticket并且页面重载时
			if (ticket) {
				console.log(ticket === localStorage.getItem('ticket'), 'opop')
				// 20260611 新增优化  || (ticket == 'null' && code)时为微信认证 不删除token
				if (ticket === localStorage.getItem('ticket') || (ticket == 'null' && wxCode)) {
					// 初始化方法
					initMethods()
				} else {
					localStorage.removeItem('token')
					let num = 0

					time.value = setInterval(() => {
						if (ticket === localStorage.getItem('ticket') && localStorage.getItem('token')) {
							num++
							console.log(num, '计数')

							clearInterval(time.value)
							time.value = null
							// 初始化方法
							initMethods()
						}
					}, 100)
				}
			} else {
				// 初始化方法 (原方法)
				initMethods()
			}
		} else {
			time.value = setInterval(() => {
				if (localStorage.getItem('token')) {
					clearInterval(time.value)
					time.value = null
					// 初始化方法
					initMethods()
				}
			}, 100)
		}

		isDev.value = window.location.href.indexOf('.dev') > -1 ? true : false
		// 绑定监听事件
		window.addEventListener('keydown', keyDown, true)
		// 根据屏幕尺寸隐藏
		getWindowHide()
		// 在窗口大小改变时执行的代码
		window.addEventListener('resize', resizeHandlerNav, false)

		// 20260408 新增检测账号切换弹窗（不同账号/退出登录）
		// 利用浏览器的visibilitychange事件，页面可见时，查询最新的缓存信息
		visibilitychangeHandle()
	})

	onUnmounted(() => {
		clearInterval(setIntervalTime.value)
		setIntervalTime.value = null
		clearInterval(time.value)
		time.value = null
		// 清除导航栏图标悬浮显示延时器
		clearTimeoutTime()

		window.removeEventListener('keydown', keyDown, true)
		window.removeEventListener('resize', resizeHandlerNav, false)
	})
</script>

<style scoped lang="scss">
	@import "@/styles/handle.scss";

	.navPage {

		.navBlo {
			@include box-shadow('box-shadow'); // nav_page_box-shadow
			@include background('common_card_back');
		}

		// .logo {
		// 	width: 142px;
		// }

		.logo {
			width: 122px;
		}

		.headerTap:hover {
			@include background('color_DCE01');
		}

		.navMenuData {
			@include color('nav_menu_color');
		}

		.headerTapHover {
			position: relative;
			// padding: 0 8px 0 12px; // 20260127新增 20260608注释 因为样式展示异常

			.headerTapHoverChild {
				display: none;
				top: 52px;
				z-index: 9999;
				padding-top: 10px;
				// z-index: 10;
			}
		}

		.headerTapHover:hover {

			.headerTapHoverChild {
				display: block;

				>div {
					padding: 8px 24px;
					@include color('header_tap_hover_color');
					@include background('header_tap_hover_back');
					@include box-shadow('box-shadow_4');
				}

				::before {
					position: absolute;
					width: 8px;
					height: 8px;
					z-index: -1;
					content: " ";
					transform: rotate(45deg);
					box-sizing: border-box;
					content: '';
					top: 6px;
					left: calc(50% - 4px);
					@include background('header_tap_hover_back');
				}
			}
		}

		.commonCardSty {
			@include border('common_card_border');
			@include background('common_card_back');
			position: absolute;
			top: $navHeight;
			left: 0;
			// z-index: 2;
			// z-index: 9999;
			z-index: 10000;
			width: 380px;
			padding: 20px 16px 24px 16px;
			box-sizing: border-box;

			.commonTitle {
				font-weight: bold;
				font-size: 16px;
				@include color('color_FFF');
				margin-bottom: 24px;
			}

			.dataBlo {
				height: 50px;
				display: flex;
				align-items: center;
				box-sizing: border-box;
				padding: 0 16px;
				column-gap: 8px;
				@include color('color_B9B');
				@include border('group_account_data_border');
				@include background('group_account_data_back');

				.img {
					display: block;
				}

				.selectImg {
					display: none;
				}
			}

			.dataBloNoAlignCenter {
				align-items: unset;
			}

			.dataBlo:hover {
				@include color('group_account_data_hover_color');
				@include border('group_account_data_hover_border');
				@include background('group_account_data_hover_back');

				.img {
					display: none;
				}

				.selectImg {
					display: block;
				}
			}

			.groupAccountData {
				width: 167px;
			}

			.resourceLibraryData,
			.serviceStationData {
				width: 107px;
			}

			.serviceStationData.paddingLR12 {
				padding: 0 12px;
			}
		}

		.avatarCardSty {
			// width: 388px;
			width: 340px;
			// height: 286px;
			left: unset;
			right: 0;
			// z-index: 2;
			z-index: 9999;
			padding: 0;

			.rzStatus {
				top: 16px;
				right: 16px;
				border-radius: 12px;
				font-size: 12px;
				line-height: 22px;
				width: 54px;
				text-align: center;
			}

			.jumpUrlData {
				padding: 8px 0;

				>div:hover {
					@include color('nav_jump_url_color');
					@include background('color_DCE1');
				}
			}
		}

		.mobileTerminalCardSty {
			width: 276px;
			padding: 16px 0 24px 0;

			.logoBlo {
				padding: 0 0 16px 24px;
			}

			.checkMarkImg {
				width: 18px;
				height: 12px;
			}
		}

		.commonDrawerSty {
			@include border('common_card_border');
			@include background('common_card_back');
			position: absolute;
			top: $navHeight;
			// z-index: 9999; 20260105新增注释
			width: 388px;
			box-sizing: border-box;
			height: calc(100vh - #{$navHeight});

			.commonDrawerTitle {
				@include border-bottom('common_card_border');
				@include color('color_FFF');
				height: 56px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 16px;
				box-sizing: border-box;
				font-weight: bold;
				font-size: 16px;

				img {
					width: 16px;
					height: 16px;
					display: block;
				}
			}

			.commonDrawerTitleSec {
				font-size: 14px;
				line-height: 14px;
				padding: 16px;
				font-weight: bold;
				@include color('color_FFF');
			}
			
			.themeTextColor {
				@include color('nav_theme_text_color');
			}

			.modeDataCommonSty {
				display: flex;
				flex-direction: column;
				padding: 0 16px;
				margin-top: 4px;
				@include border_bottom('border');

				.modeCommonSty {
					display: inline-flex;
					margin-bottom: 20px;
					column-gap: 12px;
					cursor: pointer;

					.nameSty {
						margin-bottom: 6px;
						font-size: 12px;
						line-height: 12px;
					}

					.tipsSty {
						font-size: 10px;
						line-height: 10px;
						@include color('color_B9B');
					}
				}
			}

			.themeImgBlo {
				border: 2px solid transparent;
			}

			.themeImgBloActive {
				@include border('theme_img_blo_active_border');
			}

			.themeImg {
				width: 80px;
				height: 46px;
				display: block;
			}

			.themeActiveImg {
				right: 6px;
				bottom: 6px;
			}
		}

		.commonDrawerStySec {
			left: unset !important;
			right: 0;
			position: fixed;
			z-index: 998; // 20260105新增修改 9998 => 998
		}

		.noticeDrawerSty {

			:deep(.cascaderBloSty .el-input__wrapper) {
				height: 28px;
				border-radius: 2px;
				@include border('border');
				@include background('select_back');
			}

			.noticeTabsSty {
				width: 96px;
				@include border('nav_notice_tab_border');

				.noticeTabActive {
					color: #FFFFFF;
					@include background('nav_notice_tab_active_back');
				}

				.noticeTabColor {
					@include color('nav_notice_tab_color');
				}
			}

			.noticeDataHeight {
				height: calc(100vh - 174px);

				.noticeData {
					padding: 8px 16px;

					.line {
						width: 2px;
						height: 44px;
					}

					.lineActive {
						@include background('theme_blue');
					}

					.lineDefault {
						@include background('color_343');
					}
				}

				.noticeMouseoverBack {
					@include background('nav_notice_mouseover_back');
				}
			}
		}

		.noticeNum {
			top: 12px;
			left: 20px;
			color: #FFFFFF;
		}

		.headerSearchBlo {
			width: 322px;
			height: 36px;
			padding: 10px 16px;

			.headerSearchInput {

				:deep(.el-input__wrapper) {
					background: none;
					border: none;
					border-radius: 0;
					box-shadow: none;
					padding: 0;
				}
			}

			.shortcutKeys {
				width: 56px;
				color: $color_B9B;
			}

			.searchHoverPositionBloSty {
				top: 33px; // 35px => 33px
				padding-top: 10px;

				.searchHoverBloSty {
					width: 664px;
					padding: 16px 24px;
					box-sizing: border-box;
					@include border('border');
					@include background('common_card_back');

					.titleBloSty {
						font-size: 14px;
						line-height: 14px;
						display: flex;
						justify-content: space-between;
						align-items: center;
						@include color('search_hover_title_color');

						.clearSty {
							cursor: pointer;
							@include color('nav_clear_text_color');
						}
					}

					.searchHistoryColor {
						@include color('search_history_text_color');
					}

					.searchDataHeight {
						max-height: calc(100vh - 150px);
					}

					::-webkit-scrollbar {
						display: none;
					}

					.searchDataChildBlo {
						width: 194px;
						height: 44px;
						display: flex;
						column-gap: 8px;
						align-items: center;
						padding: 0 16px;
						box-sizing: border-box;
						cursor: pointer;
						margin-top: 16px;
						border-radius: 2px;
						@include color('color_B9B');
						@include border('group_account_data_border');
						@include background('group_account_data_back');

						img {
							width: 14px;
							height: 14px;
						}

						.img {
							display: block;
						}

						.selectImg {
							display: none;
						}
					}

					.searchDataChildBloSmall {
						height: 32px;
						// width: 141.5px;
					}

					.displayN {
						display: none;
					}

					.searchDataChildBlo:hover {
						@include color('group_account_data_hover_color');
						@include border('group_account_data_hover_border');
						@include background('group_account_data_hover_back');

						.img {
							display: none;
						}

						.selectImg {
							display: block;
						}
					}

					.emptyBloSty {
						display: flex;
						column-gap: 8px;
						align-items: center;
						font-size: 12px;
						line-height: 12px;
						margin-top: 16px;
						@include color('color_B9B');

						img {
							width: 12px;
							height: 12px;
							display: block;
							margin-bottom: -1px;
						}
					}
				}
			}
		}

		.avatarSty {
			width: 28px;
			height: 28px;
			border-radius: 50%;
			cursor: pointer;
		}

		.menuBlock {
			top: $navHeight1;
			// min-width: 1116px;
			// background: $color_0005;
			height: calc(100vh - #{$navHeight1});

			.menuBack {
				position: fixed;
				left: 0;
				top: $navHeight1;
				width: auto;
				// min-width: 1116px;
				height: calc(100vh - #{$navHeight1});
			}

			.leftMenuBlo {
				// width: 244px;

				>div {
					height: 44px;
				}
			}

			.leftMenuBlo {
				width: 244px;
				transition: .3s;

				.imgWH20 {
					opacity: 1;
				}

				.fontSize14 {
					overflow: hidden;
					white-space: nowrap;
				}

				.menuDataColorActive {
					@include color('menu_data_color_active');
				}
			}

			.centerMenuBlo,
			.rightMenuBlo {
				max-width: 244px;
				min-width: 186px;
				flex-shrink: 0;
				width: 244px;
			}

			.centerMenuBlo {
				padding: 24px 16px;

				.centerMenuName {
					width: 212px;
				}

				.centerMenuChild {
					display: flex;
					flex-direction: row;
					justify-content: space-around;

					>div {
						width: 33.33%;
					}

					.centerMenuChildItem {
						margin-bottom: 8px;
						width: 100%;

						>div:first-child {
							height: 44px;
							line-height: 44px;
							@include box-shadow('box-shadow');
						}
					}
				}
			}

			.centerMenuBloPar {
				width: 732px;
				max-width: 732px;
				// width: 716px;
				// max-width: 716px;
			}

			.rightMenuBlo {
				// width: 244px;
				padding: 24px 16px;
			}

			.menuChildBlo {
				height: 32px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 12px;
				@include color('color_B9B');
				padding: 0 8px;
				box-sizing: border-box;
				cursor: pointer;
				column-gap: 4px;

				>div {
					white-space: nowrap;
					overflow: hidden;
				}

				img {
					display: none;
				}

				.collectImg {
					display: block;
				}

				.nameBloSty {
					flex: 1;
					line-height: 32px;
					height: 100%;
					overflow: hidden;
				}
			}

			.menuChildBlo:hover {
				@include color('menu_back_hover_color');
				@include background('menu_back_hover_back');

				.imgWH8 {
					display: block;
				}

				.imgWH12 {
					display: block;
				}
			}

			.menuChildBloSec {
				font-size: 12px;
				line-height: 32px;
				padding: 0 8px;
				@include color('color_FFF');
			}
		}

		.pathBloSty3 {

			.centerMenuBlo,
			.rightMenuBlo {
				width: calc(25vw - 61.5px);
			}
		}

		.pathBloSty4 {

			.centerMenuBlo,
			.rightMenuBlo {
				width: calc(20vw - 49.2px);
			}
		}
	}

	// 1222 全部功能
	@media screen and (max-width: 1222px) {

		.menuAllBlo {

			.centerMenuBloPar {
				width: calc(65vw - 62px) !important;
			}

			.rightMenuBlo {
				width: calc(24.94vw - 62px) !important;
			}
		}
	}

	// 1174达到最小尺寸 左侧菜单固定尺寸
	@media screen and (max-width: 1174px) {

		.menuAllBlo {

			.centerMenuBloPar {
				width: 732px !important;
			}

			.rightMenuBlo {
				width: 244px !important;
			}
		}

		.leftMenuBlo {
			width: 92px !important;

			.imgWH20 {
				opacity: 0;
				display: none !important;
			}

			.fontSize14 {
				width: 28px;
			}
		}

		.pathBloSty3 {

			.centerMenuBlo,
			.rightMenuBlo {
				width: calc(25vw - 23.5px) !important;
			}
		}

		.pathBloSty4 {

			// 左侧菜单不变 1174达到最小尺寸
			.centerMenuBlo,
			.rightMenuBlo {
				width: calc(20vw - 18.7px) !important;
			}

		}
	}

	// 1068 全部功能
	@media screen and (max-width: 1068px) {

		.menuAllBlo {

			.centerMenuBloPar {
				width: calc(73vw - 49.9px) !important;
			}

			.rightMenuBlo {
				width: calc(25vw - 23.5px) !important;
			}
		}
	}

	.spotSty {
		width: 4px;
		height: 4px;
		top: -2px;
		right: -6px;
		@include background('cursor_color');
	}

	::-webkit-scrollbar {
		display: none;
	}


	.sdk-nav-v2-nav-menu {
		height: 52px;
		width: 52px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		position: relative;
	}

	.sdk-nav-v2-nav-menu.fold {
		@include background('sdk-nav-v2-nav-menu_back');
		// background-color: var(--nav-hamburger-color-bg-hover);
		transition: all .5s ease-out;
	}

	.sdk-nav-v2-nav-menu.unfold {
		background-color: transparent;
		transition: all .5s ease-out;
	}

	.sdk-nav-v2-nav-menu__line,
	.sdk-nav-v2-nav-menu__line-first,
	.sdk-nav-v2-nav-menu__line-last {
		width: 18px;
		height: 2px;
		transform: scaleY(70%);
		position: absolute;
		left: calc(50% - 9px);
		@include background('nav_menu_line_back');
	}

	.sdk-nav-v2-nav-menu__line-first {
		top: calc(50% - 7px);
	}

	.sdk-nav-v2-nav-menu__line {
		top: calc(50% - 1px);
	}

	.sdk-nav-v2-nav-menu__line-last {
		bottom: calc(50% - 7px);
	}

	.sdk-nav-v2-nav-menu.fold .sdk-nav-v2-nav-menu__line-first {
		animation: sdk-nav-v2-menu-line-first .5s ease-out forwards;
	}

	.sdk-nav-v2-nav-menu.fold .sdk-nav-v2-nav-menu__line-last {
		animation: sdk-nav-v2-menu-line-last .5s ease-out forwards;
	}

	.sdk-nav-v2-nav-menu.fold .sdk-nav-v2-nav-menu__line {
		animation: sdk-nav-v2-menu-line .5s ease-out forwards;
	}

	.sdk-nav-v2-nav-menu.unfold .sdk-nav-v2-nav-menu__line-first {
		animation: sdk-nav-v2-menu-line-first-inverse .5s ease-out forwards;
	}

	.sdk-nav-v2-nav-menu.unfold .sdk-nav-v2-nav-menu__line-last {
		animation: sdk-nav-v2-menu-line-last-inverse .5s ease-out forwards;
	}

	.sdk-nav-v2-nav-menu.unfold .sdk-nav-v2-nav-menu__line {
		animation: sdk-nav-v2-menu-line-inverse .5s ease-out forwards;
	}

	@keyframes sdk-nav-v2-menu-line-first {
		0% {
			top: calc(50% - 7px);
			transform: rotate(0) scaleY(70%);
		}

		60% {
			top: calc(50% - 1px);
			transform: rotate(0) scaleY(70%);
		}

		75% {
			top: calc(50% - 1px);
			transform: rotate(68deg) scaleY(70%);
			background: hsla(0, 0%, 100%, 0.9);
			// background-color: var(--tea-color-text-highlight-inverse-primary);
		}

		to {
			top: calc(50% - 1px);
			transform: rotate(135deg) scaleY(70%);
			background: hsla(0, 0%, 100%, 0.9);
			// background-color: var(--tea-color-text-highlight-inverse-primary);
		}
	}

	@keyframes sdk-nav-v2-menu-line-last {
		0% {
			bottom: calc(50% - 7px);
			transform: rotate(0) scaleY(70%)
		}

		60% {
			bottom: calc(50% - 1px);
			transform: rotate(0) scaleY(70%)
		}

		to {
			bottom: calc(50% - 1px);
			transform: rotate(45deg) scaleY(70%);
			background: hsla(0, 0%, 100%, 0.9);
			// background-color: var(--tea-color-text-highlight-inverse-primary);
		}
	}

	@keyframes sdk-nav-v2-menu-line {
		0% {
			opacity: 1
		}

		50% {
			opacity: 1
		}

		to {
			opacity: 0
		}
	}

	@keyframes sdk-nav-v2-menu-line-first-inverse {
		0% {
			top: calc(50% - 1px);
			transform: rotate(135deg) scaleY(70%);
			background: hsla(0, 0%, 100%, 0.9);
			// background-color: var(--tea-color-text-highlight-inverse-primary);
		}

		20% {
			top: calc(50% - 1px);
			transform: rotate(68deg) scaleY(70%);
			background: hsla(0, 0%, 100%, 0.9);
			// background-color: var(--tea-color-text-highlight-inverse-primary);;
		}

		40% {
			top: calc(50% - 1px);
			transform: rotate(0) scaleY(70%);
			background: hsla(0, 0%, 100%, 0.9);
			// background-color: var(--tea-color-text-highlight-inverse-primary);
		}

		54% {
			top: calc(50% - 1px);
			transform: rotate(0) scaleY(70%);
			background-color: var(--tea-color-text-primary);
		}

		to {
			top: calc(50% - 7px);
			transform: rotate(0) scaleY(70%);
			background-color: var(--tea-color-text-primary);
		}
	}

	@keyframes sdk-nav-v2-menu-line-last-inverse {
		0% {
			bottom: calc(50% - 1px);
			transform: rotate(45deg) scaleY(70%);
			background: hsla(0, 0%, 100%, 0.9);
			// background-color: var(--tea-color-text-highlight-inverse-primary);
		}

		40% {
			bottom: calc(50% - 1px);
			transform: rotate(0) scaleY(70%);
			background: hsla(0, 0%, 100%, 0.9);
			// background-color: var(--tea-color-text-highlight-inverse-primary);
		}

		54% {
			bottom: calc(50% - 1px);
			transform: rotate(0) scaleY(70%);
			background-color: var(--tea-color-text-primary);
		}

		to {
			bottom: calc(50% - 7px);
			transform: rotate(0) scaleY(70%);
			background-color: var(--tea-color-text-primary);
		}
	}

	@keyframes sdk-nav-v2-menu-line-inverse {
		0% {
			opacity: 0
		}

		50% {
			opacity: 0
		}

		to {
			opacity: 1
		}
	}

	@media screen and (max-width: 1290px) {

		.headerSearchBlo {
			width: 100% !important;

			.headerSearchInput {
				max-width: 155px !important;
			}
		}
	}

	.padding12_16 {
		padding: 12px 16px;
	}

	.displayNSmall {
		display: none !important;
	}

	.navAvatarBlo {

		.nameColor {
			@include color('nav_avatar_name_color');
		}

		.depColor {
			@include color('nav_avatar_dep_color');
		}
	}

	.bigTitleAllSty {
		@include color('nav_big_title_color');
	}

	.logoutText {
		@include color('logout_text_color');
	}

	.noDataText {
		@include color('nav_no_data_text_color');
	}

	.receiveTime {
		@include color('nav_receive_time_text_color');
	}

	:deep(.el-checkbox__label) {
		font-size: 10px !important;
		padding-left: 8px !important;
	}

	:deep(.el-checkbox) {
		height: 16px !important;
		margin-bottom: 16px !important;
	}

	:deep(.el-button) {
		width: 80px !important;
		font-size: 12px !important;
	}
</style>